PS.populateFluidDropdown = function () {
  const select = document.getElementById('fluid-select');

  if (!select) {
    return;
  }

  const fluids = PS.getFluidArray();

  select.innerHTML = '';

  if (!fluids.length) {
    const option = document.createElement('option');
    option.value = '';
    option.textContent = 'No fluids loaded';
    select.appendChild(option);
    return;
  }

  fluids.forEach(fluid => {
    const option = document.createElement('option');
    option.value = fluid.id;
    option.textContent = fluid.name;
    select.appendChild(option);
  });

  const hasWater = fluids.some(fluid => fluid.id === 'water');
  select.value = hasWater ? 'water' : fluids[0].id;

  PS.updateFluidProperties();
};

// Returns density (kg/L) and viscosity (cP) for a fluid at the given temperature.
//
// Water: uses the TAPS quadratic polynomial (GpSelect2.txt line 1579):
//   SG = Round(1.004152 - 0.0001626777*T - 0.000002890946*T², 3)
// Viscosity is kept at 1 cP for water at all temperatures — TAPS makes
// no viscosity correction to pump performance, and cold water (~1.8 cP)
// must not trigger the ANSI/HI 9.6.7 viscosity correction.
//
// Non-water fluids: linearly interpolated from the fluid's properties[]
// temperature table (density and viscosity both vary). The interpolated
// viscosity feeds the ANSI/HI 9.6.7 correction (cSt = cP / density),
// so accuracy at operating temperature matters — glycols and oils can
// change by an order of magnitude between cold and hot.
PS.getFluidPropertiesAtTemperature = function (fluid, temperatureC) {
  const T = Number(temperatureC) || 20;

  if (fluid.id === 'water') {
    const sg = Math.round((1.004152 - 0.0001626777 * T - 0.000002890946 * T * T) * 1000) / 1000;
    return { densityKgL: sg, viscosityCp: 1 };
  }

  const properties = Array.isArray(fluid.properties) ? fluid.properties : [];

  if (!properties.length) {
    return {
      densityKgL: Number(fluid.densityKgL || 1),
      viscosityCp: Number(fluid.viscosityCp || 1)
    };
  }

  const sorted = [...properties].sort((a, b) => Number(a.temperatureC) - Number(b.temperatureC));

  if (T <= Number(sorted[0].temperatureC)) {
    return { densityKgL: Number(sorted[0].densityKgL), viscosityCp: Number(sorted[0].viscosityCp) };
  }
  if (T >= Number(sorted[sorted.length - 1].temperatureC)) {
    const last = sorted[sorted.length - 1];
    return { densityKgL: Number(last.densityKgL), viscosityCp: Number(last.viscosityCp) };
  }

  const lower = [...sorted].reverse().find(row => T >= Number(row.temperatureC));
  const upper = sorted.find(row => T > Number(lower.temperatureC) && T <= Number(row.temperatureC));

  if (!lower || !upper) {
    return { densityKgL: Number(fluid.densityKgL || 1), viscosityCp: Number(fluid.viscosityCp || 1) };
  }

  const ratio = (T - Number(lower.temperatureC)) / (Number(upper.temperatureC) - Number(lower.temperatureC));

  return {
    densityKgL: Number(lower.densityKgL) + (Number(upper.densityKgL) - Number(lower.densityKgL)) * ratio,
    viscosityCp: Number(lower.viscosityCp) + (Number(upper.viscosityCp) - Number(lower.viscosityCp)) * ratio
  };
};

PS.updateFluidProperties = function () {
  const densityInput = document.getElementById('fluid-density');
  const viscosityInput = document.getElementById('fluid-viscosity');

  if (!densityInput || !viscosityInput) {
    return;
  }

  const fluidId = document.getElementById('fluid-select')?.value || 'water';
  const temperatureC = Number(document.getElementById('fluid-temperature')?.value || 20);

  const fluid = PS.getFluidArray().find(item => item.id === fluidId);

  // Show a disclaimer when a non-water fluid is selected so the user
  // confirms the pre-populated density/viscosity values before proceeding.
  const fluidSelect = document.getElementById('fluid-select');
  if (fluidSelect) {
    const NOTE_ID = 'fluid-properties-note';
    let note = document.getElementById(NOTE_ID);

    if (fluidId !== 'water') {
      if (!note) {
        note = document.createElement('p');
        note.id = NOTE_ID;
        note.style.cssText = 'margin:6px 0 0;font-size:0.82em;color:#856404;background:#fff3cd;border:1px solid #ffc107;border-radius:4px;padding:6px 10px;';
        fluidSelect.parentNode.insertAdjacentElement('afterend', note);
      }
      note.textContent =
        'While we take care that these values are as correct as possible, please confirm the density and viscosity before selecting a pump.';
      note.style.display = 'block';
    } else if (note) {
      note.style.display = 'none';
    }
  }

  if (!fluid) {
    densityInput.value = '';
    viscosityInput.value = '';
    return;
  }

  const props = PS.getFluidPropertiesAtTemperature(fluid, temperatureC);

  densityInput.value = Number(props.densityKgL).toFixed(3);
  viscosityInput.value = Number(props.viscosityCp).toFixed(2);
};

PS.captureDutyInputs = function () {
  PS.unitSettings.flow = document.getElementById('duty-flow-unit').value;
  PS.unitSettings.head = document.getElementById('duty-head-unit').value;

  const flowInput = Number(document.getElementById('pump-flow').value);
  const headInput = Number(document.getElementById('pump-head').value);
  const suctionInput = Number(document.getElementById('pump-suction')?.value || 0);

  const poleFilter = ['2', '4', '6', '8']
    .filter(poles => document.getElementById(`pole-filter-${poles}`)?.checked)
    .map(Number);

  const phaseRadio = document.querySelector('input[name="phase-filter"]:checked');
  const phaseVal = phaseRadio ? Number(phaseRadio.value) || null : null;
  PS.state.selectedPhase = phaseVal;
  // The supply the customer says they have seeds the motor phase on whatever
  // they go on to select, so a single-phase search doesn't hand them a pump
  // and then default it to a three-phase motor. "Any" leaves it unset, which
  // PS.getEffectiveMotorPhase reads as three phase - the safe default, and
  // still switchable per pump afterwards.
  PS.state.selectedMotorPhase = phaseVal;

  const applicationRadio = document.querySelector('input[name="application-filter"]:checked');
  const applicationVal = applicationRadio ? applicationRadio.value || null : null;
  PS.state.selectedApplicationType = applicationVal;

  PS.state.duty = {
    flow: PS.flowToBase(flowInput),
    head: PS.headToBase(headInput),
    suctionLift: PS.headToBase(suctionInput),
    totalHead: PS.headToBase(headInput) + PS.headToBase(suctionInput),
    controlType: document.getElementById('control-type')?.value || 'fixed',
    poleFilter,
    phase: phaseVal,
    applicationType: applicationVal,
    speedRangeMinRpm: Number(document.getElementById('speed-range-min')?.value || 0),
    speedRangeMaxRpm: Number(document.getElementById('speed-range-max')?.value || 0),
    fluidId: document.getElementById('fluid-select').value,
    temperatureC: Number(document.getElementById('fluid-temperature').value),
    densityKgL: Number(document.getElementById('fluid-density').value),
    viscosityCp: Number(document.getElementById('fluid-viscosity').value)
  };

  return PS.state.duty;
};

// The speed-range RPM inputs only mean anything for the engine/diesel-drive
// control type - keep them hidden otherwise so they're not mistaken for an
// active filter on every search. A diesel/engine duty is also defined by its
// RPM range rather than a motor pole count, so the pole filter is hidden (and
// cleared) whenever speed-range mode is active.
PS.wireSpeedRangeVisibility = function () {
  const controlTypeSelect = document.getElementById('control-type');
  const speedRangeRow = document.getElementById('speed-range-row');
  const poleFilterRow = document.getElementById('pole-filter-row');

  if (!controlTypeSelect || !speedRangeRow) return;

  const phaseFilterRow = document.getElementById('phase-filter-row');
  const singlePhaseRadio = document.getElementById('phase-filter-1');
  const singlePhaseLabel = document.getElementById('phase-filter-1-label');
  const anyPhaseRadio = document.getElementById('phase-filter-any');
  const phaseHint = document.getElementById('phase-filter-hint');

  const updateVisibility = () => {
    const isSpeedRange = controlTypeSelect.value === 'speedRange';
    const isVsd = controlTypeSelect.value === 'vsd';
    speedRangeRow.style.display = isSpeedRange ? 'grid' : 'none';

    if (poleFilterRow) {
      poleFilterRow.style.display = isSpeedRange ? 'none' : '';
      if (isSpeedRange) {
        poleFilterRow.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
          checkbox.checked = false;
        });
      }
    }

    // Power supply only means something when an electric motor is driving the
    // pump. An engine/diesel duty has no motor at all, so the whole question
    // is hidden; a VSD duty has one but it must be three phase, because a
    // single-phase motor cannot be speed-varied (variable speed on a
    // single-phase supply means a 230V three-phase motor on a single-phase-
    // input drive, which is a different motor to anything catalogued here).
    if (phaseFilterRow) phaseFilterRow.style.display = isSpeedRange ? 'none' : '';

    if (singlePhaseRadio) {
      singlePhaseRadio.disabled = isVsd || isSpeedRange;

      if (singlePhaseRadio.disabled && singlePhaseRadio.checked && anyPhaseRadio) {
        anyPhaseRadio.checked = true;
      }
    }

    if (singlePhaseLabel) singlePhaseLabel.style.opacity = (isVsd || isSpeedRange) ? '0.45' : '';

    if (phaseHint) {
      phaseHint.style.display = isVsd ? '' : 'none';
      phaseHint.textContent = isVsd
        ? 'Single phase is not available on a VSD - a single-phase motor cannot be speed-varied.'
        : '';
    }
  };

  controlTypeSelect.addEventListener('change', updateVisibility);
  updateVisibility();
};

// The Pump application (Drainage / Sewage) fieldset only means anything for
// Jung Pumpen's submergible range - every sewage pump doubles as a
// drainage pump but not every drainage pump is sewage-rated (see
// docs/manufacturers.md), so the customer must say which they need before a
// submergible search can run. Hidden (and cleared) outside the submergible
// category so it can't leave a stale selection silently filtering a
// Centrifugal (Southern Cross/Onga/Caprari) search, none of whose curves set
// applicationTypes at all. Call after PS.state.selectedCategory changes
// (category tile click, session/URL restore).
PS.updateApplicationFilterVisibility = function () {
  const row = document.getElementById('application-filter-row');
  if (!row) return;

  const isSubmergible = PS.state.selectedCategory === 'submergible';
  row.style.display = isSubmergible ? '' : 'none';

  if (!isSubmergible) {
    row.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.checked = false;
    });
    PS.state.selectedApplicationType = null;
  }
};

PS.showCategoryView = function () {
  document.getElementById('category-view').style.display = 'block';
  document.getElementById('pump-search-wrapper').style.display = 'none';
};

PS.showSearchWrapper = function () {
  document.getElementById('category-view').style.display = 'none';
  document.getElementById('pump-search-wrapper').style.display = 'block';
};

PS.showDutyInputView = function () {
  PS.showSearchWrapper();
  document.getElementById('duty-input-view').style.display = 'block';
  document.getElementById('duty-results-view').style.display = 'none';
  document.getElementById('model-view').style.display = 'none';
  document.getElementById('detail-view').style.display = 'none';
};

PS.showDutyResultsView = function () {
  PS.showSearchWrapper();
  document.getElementById('duty-input-view').style.display = 'none';
  document.getElementById('duty-results-view').style.display = 'block';
  document.getElementById('model-view').style.display = 'none';
  document.getElementById('detail-view').style.display = 'none';
};

// Scoped to whichever landing-page category is active (PS.getCurvesArrayForCategory)
// so e.g. a Jung "submergible" pump type never shows up while browsing under
// the Centrifugal tile, and vice versa. Rebuilds each select's option list
// from scratch (keeping only its first/blank placeholder option) rather than
// just appending missing ones, since switching category can shrink the list
// as well as grow it - a stale option from the previous category must not
// remain selectable.
PS.populatePumpTypeDropdowns = function () {
  const selects = [
    document.getElementById('pump-type-filter'),
    document.getElementById('model-pump-type')
  ].filter(Boolean);

  const types = [
    ...new Set(
      PS.getCurvesArrayForCategory()
        .map(curve => curve.pumpType)
        .filter(Boolean)
    )
  ].sort();

  selects.forEach(select => {
    while (select.options.length > 1) {
      select.remove(1);
    }

    types.forEach(type => {
      const option = document.createElement('option');
      option.value = type;
      option.textContent = type;
      select.appendChild(option);
    });

    select.value = '';
  });
};

PS.populateMaterialDropdown = function () {
  const select = document.getElementById('pump-material-select');
  const label = document.getElementById('pump-material-row');
  if (!select) return;

  const selectedMatch = PS.state.currentMatches?.[PS.state.currentSelectedIndex];
  const curve = selectedMatch?.curve || selectedMatch;
  const variants = curve?.familyMetadata?.materialVariants;

  select.innerHTML = '';

  if (variants?.length) {
    // PT/PW-style families: show specific material variants, no derating
    if (label) label.firstChild.textContent = 'Material';
    variants.forEach(v => {
      const option = document.createElement('option');
      option.value = v.series;
      option.textContent = v.label;
      select.appendChild(option);
    });
    select.value = PS.state.selectedVariantSeries;
    if (!variants.find(v => v.series === select.value)) select.value = variants[0].series;
  } else {
    // Standard TAPS material derating options
    if (label) label.firstChild.textContent = 'Material (Volute/Impeller)';
    PS.materialOptions.forEach(material => {
      const option = document.createElement('option');
      option.value = material.value;
      option.textContent = material.label;
      select.appendChild(option);
    });
    select.value = PS.state.selectedMaterial;
  }
};

// The material dropdown only makes sense for end-suction pumps that TAPS
// itself derates by casing/impeller material (see PS.supportsMaterialSelection) -
// verticals are stainless-only, so hide the control whenever the currently
// selected match doesn't support it, rather than offer a choice with no effect.
PS.updateMaterialRowVisibility = function () {
  const row = document.getElementById('pump-material-row');

  if (!row) {
    return;
  }

  const selectedMatch = PS.state.currentMatches?.[PS.state.currentSelectedIndex];
  const supported = Boolean(selectedMatch) && PS.supportsMaterialSelection(selectedMatch);

  row.style.display = supported ? 'flex' : 'none';
};

PS.populateModelFamilies = function () {
  const type = document.getElementById('model-pump-type').value;
  const familySelect = document.getElementById('model-pump-family');
  const motorSelect = document.getElementById('model-motor-selection');
  const trimRow = document.getElementById('model-trim-row');

  familySelect.innerHTML = '<option value="">Select pump model</option>';
  motorSelect.innerHTML = '<option value="">Select motor</option>';
  if (trimRow) trimRow.style.display = 'none';

  PS.state.modelMotorOptions = [];

  const curves = PS.getCurvesArrayForCategory().filter(curve => !type || curve.pumpType === type);
  const families = [...new Set(curves.map(PS.getPumpFamily).filter(Boolean))].sort();

  families.forEach(family => {
    // Every curve in a family shares the same casing/suction-discharge size,
    // so the first curve's size description is representative of the whole
    // family - shown alongside the bare family code so the dropdown isn't
    // just an opaque list of model codes.
    const sizeDescription = PS.getPumpSizeDescription(curves.find(curve => PS.getPumpFamily(curve) === family));

    const option = document.createElement('option');
    option.value = family;
    option.textContent = sizeDescription ? `${family} - ${sizeDescription}` : family;
    familySelect.appendChild(option);
  });
};

// Curves for whatever pump type + pump model are currently picked in the
// One entry per impeller stack for the Configuration dropdowns. A PVMI family
// catalogues both builds of most stacks (PVMI15-03S and PVMI15-03T), and they
// are hydraulically identical - listing both would offer the customer the same
// pump twice and put phase in two places at once. Phase is chosen in Motor
// Selection now, so the dropdown carries the stack and the T build stands in
// as its canonical curve.
PS.getVerticalStackCurves = function (familyCurves) {
  const byStack = new Map();

  (familyCurves || []).forEach(curve => {
    const stack = PS.getVerticalCurveStackCode(curve);
    if (!stack) return;
    // Prefer the three-phase build; fall back to whatever this stack has.
    if (!byStack.has(stack) || PS.getVerticalCurvePhase(curve) === 3) byStack.set(stack, curve);
  });

  return [...byStack.values()].sort((a, b) => {
    const stageDiff = PS.getStages(a) - PS.getStages(b);
    return stageDiff || String(a.unitCode || a.id).localeCompare(String(b.unitCode || b.id));
  });
};

// "search by pump model" dropdowns - shared by the motor-size/stage
// population and by the Load Pump handler so both read the same set.
PS.getModelFamilyCurves = function () {
  const type = document.getElementById('model-pump-type').value;
  const family = document.getElementById('model-pump-family').value;

  if (!family) return [];

  return PS.getCurvesArrayForCategory().filter(curve =>
    (!type || curve.pumpType === type) && PS.getPumpFamily(curve) === family
  );
};

PS.populateMotorSelections = function () {
  const motorSelect = document.getElementById('model-motor-selection');
  const motorLabel = document.getElementById('model-motor-label');
  const motorRow = document.getElementById('model-motor-row');
  const trimRow = document.getElementById('model-trim-row');

  motorSelect.innerHTML = '<option value="">Select motor</option>';
  if (motorRow) motorRow.style.display = '';
  if (trimRow) trimRow.style.display = 'none';

  PS.state.modelMotorOptions = [];

  const familyCurves = PS.getModelFamilyCurves();

  if (!familyCurves.length) return;

  // Onga fixed pumps (OME/JS etc) have no trim and no motor database entry -
  // there's nothing to pick beyond the model itself, so hide both controls
  // rather than show an empty, unusable motor dropdown that blocks Load.
  if (familyCurves.every(curve => curve.fixedPump)) {
    if (motorRow) motorRow.style.display = 'none';
    return;
  }

  const isVertical = familyCurves.every(PS.isVerticalMultistage);

  if (isVertical) {
    if (motorLabel) motorLabel.textContent = 'Configuration';

    PS.getVerticalStackCurves(familyCurves).forEach(curve => {
      const option = document.createElement('option');
      option.value = curve.id || curve.unitCode;
      option.textContent = PS.getVerticalCurveLabel(curve);
      motorSelect.appendChild(option);
    });

    return;
  }

  if (motorLabel) motorLabel.textContent = 'Motor size';
  if (trimRow) trimRow.style.display = '';

  PS.state.modelMotorOptions = PS.getMotorSizeOptionsForFamily(familyCurves);

  PS.state.modelMotorOptions.forEach((option, index) => {
    const opt = document.createElement('option');
    opt.value = String(index);
    opt.textContent = `${PS.formatNumber(option.motor.powerKw, 2)} kW / ${option.motor.poles} pole`;
    motorSelect.appendChild(opt);
  });

  PS.updateModelTrimDefault();
};

// Refreshes the trim input to whatever default the currently-selected
// motor size implies - only called on motor change, so a value the
// customer has manually tweaked for the previous motor isn't clobbered
// until they actually pick a different motor.
PS.updateModelTrimDefault = function () {
  const motorSelect = document.getElementById('model-motor-selection');
  const trimInput = document.getElementById('model-trim');

  if (!trimInput) return;

  const selected = (PS.state.modelMotorOptions || [])[Number(motorSelect.value)];

  trimInput.value = selected ? selected.defaultTrimMm : '';
};

PS.getStockInfo = function (matchOrCurve) {
  const curve = matchOrCurve?.curve || matchOrCurve;
  if (!curve) return null;

  const rawStatus = curve.stockStatus ?? curve.stock?.status ?? (typeof curve.stocked === 'boolean' ? (curve.stocked ? 'stocked' : 'not_stocked') : null);
  const status = rawStatus == null
    ? null
    : String(rawStatus).trim().toLowerCase().replace(/[\s-]+/g, '_');
  const note = curve.stockNote || curve.stock?.note || '';

  if (status) {
    const labels = {
      stocked: 'Stocked',
      in_stock: 'Stocked',
      not_stocked: 'Not stocked',
      non_stock: 'Not stocked',
      indent: 'Indent item',
      indent_item: 'Indent item',
      special_order: 'Special order',
      order_in: 'Order in'
    };
    const classes = {
      stocked: 'is-stocked',
      in_stock: 'is-stocked',
      not_stocked: 'is-not-stocked',
      non_stock: 'is-not-stocked',
      indent: 'is-indent',
      indent_item: 'is-indent',
      special_order: 'is-indent',
      order_in: 'is-indent'
    };

    return {
      status,
      label: labels[status] || String(rawStatus),
      className: classes[status] || 'is-note',
      note
    };
  }

  if (PS.isPwtFamily?.(PS.getPumpFamily(curve))) {
    return {
      status: 'indent',
      label: 'Indent item',
      className: 'is-indent',
      note: note || 'Confirm stock/lead time with 43 South.'
    };
  }

  return note ? {
    status: 'note',
    label: 'Stock note',
    className: 'is-note',
    note
  } : null;
};

PS.renderStockBadge = function (matchOrCurve) {
  const stock = PS.getStockInfo(matchOrCurve);
  if (!stock) return '';

  return `
    <span class="pump-stock-badge ${stock.className}">
      ${stock.label}${stock.note ? `: ${stock.note}` : ''}
    </span>
  `;
};

PS.renderMatchButton = function (match, index) {
  const checked = PS.state.visibleMatchIndexes.has(index) ? 'checked' : '';
  const color = PS.getMatchColor(index);
  const displayName = PS.getPumpDisplayName(match);
  const family = PS.getPumpFamily(match.curve || match);
  const manufacturer = PS.getManufacturerLabel(match);
  const efficiencyText = match.efficiency !== null && match.efficiency !== undefined
    ? PS.formatNumber(match.efficiency)
    : '-';

  // Duty-point absorbed shaft power - the same figure the detail summary
  // shows as "Power" and the printed curve sheet as "Duty power", read
  // straight off the match rather than recomputed, so the card can't drift
  // from the sheet behind it. Null for curves with no fitted power
  // polynomial (Onga OME), which already show "-" for efficiency for
  // exactly the same reason.
  const powerText = Number.isFinite(match.power)
    ? PS.formatNumber(PS.powerFromBase(match.power))
    : '-';

  // Units live in the cell labels rather than beside each value: the
  // results column is only ~230px wide (200px on landscape phones), and a
  // value carrying its own unit doesn't fit three-across without wrapping
  // mid-figure.
  const metrics = [
    ['Head', PS.getHeadUnitText(), PS.formatNumber(PS.headFromBase(match.predictedHead))],
    ['Power', PS.getPowerUnitText(), powerText],
    ['Eff', '%', efficiencyText]
  ];

  return `
    <div
      class="pump-match-button ${checked ? 'is-visible' : ''}"
      data-match-index="${index}"
      style="--match-color:${color};"
    >
      <input
        type="checkbox"
        class="pump-match-checkbox"
        data-match-index="${index}"
        ${checked}
      >

      <button
        type="button"
        class="pump-match-label"
        data-match-index="${index}"
      >
        ${manufacturer ? `<span class="pump-match-mfr">${manufacturer}</span>` : ''}
        <strong>${displayName}</strong> <span>(${family})</span>
        ${match.isVertical ? `<span class="pump-match-config">&middot; ${PS.getVerticalUnitModelCode(match)}</span>` : ''}

        <span class="pump-match-metrics">
          ${metrics.map(([label, unit, value]) => `
            <span class="pump-match-metric">
              <span class="pump-match-metric-label">${label}${unit ? ` ${unit}` : ''}</span>
              <span class="pump-match-metric-value">${value}</span>
            </span>
          `).join('')}
        </span>

        ${PS.renderStockBadge(match)}
      </button>
    </div>
  `;
};

PS.updateMatchButtonStates = function () {
  document.querySelectorAll('.pump-match-button').forEach((box, index) => {
    const checkbox = box.querySelector('.pump-match-checkbox');

    const visible = PS.state.visibleMatchIndexes.has(index);
    const focused = PS.state.focusedMatchIndex === index;

    box.classList.toggle('is-visible', visible);
    box.classList.toggle('is-focused', focused);
    box.classList.toggle('is-faded', PS.state.focusedMatchIndex !== null && !focused);

    if (checkbox) {
      checkbox.checked = visible;
    }
  });

  PS.updateMaterialRowVisibility();

  const nextButton = document.getElementById('pump-next-btn');

  if (nextButton) {
    nextButton.disabled = !PS.state.currentMatches[PS.state.currentSelectedIndex];
  }
};

PS.renderMatches = function (matches) {
  const result = document.getElementById('pump-result');

  if (!matches.length) {
    PS.state.currentMatches = [];
    PS.state.currentSelectedIndex = 0;
    PS.state.focusedMatchIndex = null;
    PS.state.visibleMatchIndexes = new Set();

    result.innerHTML = '<strong>No suitable pump found.</strong>';

    PS.updateMatchButtonStates();

    return;
  }

  PS.state.currentMatches = matches.slice(0, 10);
  PS.state.currentSelectedIndex = 0;
  PS.state.focusedMatchIndex = null;
  PS.state.visibleMatchIndexes = new Set([0]);

  result.innerHTML = PS.state.currentMatches
    .map((match, index) => PS.renderMatchButton(match, index))
    .join('');

  document.querySelectorAll('.pump-match-checkbox').forEach(checkbox => {
    checkbox.addEventListener('click', event => {
      event.stopPropagation();

      const index = Number(checkbox.dataset.matchIndex);

      if (checkbox.checked) {
        PS.state.visibleMatchIndexes.add(index);
        PS.state.currentSelectedIndex = index;
      } else {
        PS.state.visibleMatchIndexes.delete(index);

        if (PS.state.focusedMatchIndex === index) {
          PS.state.focusedMatchIndex = null;
        }

        if (PS.state.visibleMatchIndexes.size === 0) {
          PS.state.visibleMatchIndexes.add(index);
          checkbox.checked = true;
        }

        PS.state.currentSelectedIndex = [...PS.state.visibleMatchIndexes][0];
      }

      PS.updateMatchButtonStates();

      PS.drawChart(
        'pump-chart',
        'duty',
        PS.state.currentMatches,
        PS.state.visibleMatchIndexes,
        PS.state.dutyModes,
        PS.state.currentSelectedIndex
      );

      PS.renderSearchSummary();
    });
  });

  document.querySelectorAll('.pump-match-label').forEach(button => {
    button.addEventListener('click', () => {
      const index = Number(button.dataset.matchIndex);

      if (PS.state.focusedMatchIndex === index) {
        PS.state.focusedMatchIndex = null;
      } else {
        PS.state.focusedMatchIndex = index;
        PS.state.currentSelectedIndex = index;

        if (!PS.state.visibleMatchIndexes.has(index)) {
          PS.state.visibleMatchIndexes.add(index);
        }
      }

      PS.updateMatchButtonStates();

      PS.drawChart(
        'pump-chart',
        'duty',
        PS.state.currentMatches,
        PS.state.visibleMatchIndexes,
        PS.state.dutyModes,
        PS.state.currentSelectedIndex
      );

      PS.renderSearchSummary();
    });
  });

  PS.selectSearchMatch(0);
};

PS.selectSearchMatch = function (index) {
  const prevMatch = PS.state.currentMatches?.[PS.state.currentSelectedIndex];
  PS.state.currentSelectedIndex = index;
  PS.state.visibleMatchIndexes.add(index);

  // Reset variant selection to first option when switching to a different family
  const newMatch = PS.state.currentMatches?.[index];
  const newVariants = newMatch?.curve?.familyMetadata?.materialVariants;
  const prevVariants = prevMatch?.curve?.familyMetadata?.materialVariants;
  if (newVariants?.length && newVariants !== prevVariants) {
    PS.state.selectedVariantSeries = newVariants[0].series;
  }

  PS.updateMatchButtonStates();

  PS.drawChart(
    'pump-chart',
    'duty',
    PS.state.currentMatches,
    PS.state.visibleMatchIndexes,
    PS.state.dutyModes,
    PS.state.currentSelectedIndex
  );

  PS.renderSearchSummary();
};

PS.renderSearchSummary = function () {
  const details = document.getElementById('pump-selected-details');

  const selected = [...PS.state.visibleMatchIndexes]
    .map(index => PS.state.currentMatches[index])
    .filter(Boolean);

  if (!selected.length) {
    details.innerHTML = '<h3>Pump Options</h3><p>Select one or more pumps to compare.</p>';
    return;
  }

  details.innerHTML = `
    <h3>Pump Options</h3>

    <div class="pump-detail-grid">
      ${selected.map(match => `
        <div class="pump-detail-item">
          <div class="pump-detail-label">${PS.getPumpDisplayName(match)}</div>
          <div class="pump-detail-value">${PS.formatNumber(PS.headFromBase(match.predictedHead))} ${PS.getHeadUnitText()}</div>
        </div>
      `).join('')}
    </div>
  `;
};

PS.renderDetailSummary = function (targetId, match, titleId) {
  const details = document.getElementById(targetId);
  const titleEl = titleId ? document.getElementById(titleId) : null;

  if (!match) {
    if (titleEl) titleEl.textContent = '';
    return;
  }

  if (!details) {
    return;
  }

  const displayName = PS.getPumpDisplayName(match);

  if (titleEl) {
    titleEl.textContent = `Selected Pump: ${displayName}`;
  }

  details.innerHTML = `
    <div class="pump-detail-grid">
      ${PS.getDetailRows(match).map(([label, value]) => `
        <div class="pump-detail-item">
          <div class="pump-detail-label">${label}</div>
          <div class="pump-detail-value">${value}</div>
        </div>
      `).join('')}
    </div>
  `;
};

// Shared by the on-screen detail summary and the printable curve sheet, so
// the two never drift out of sync with each other.
PS.getDetailRows = function (match) {
  const motor = PS.getDisplayMotor(match);
  const unitEff = PS.calculateUnitEfficiencyForMotor(match, motor);
  const stock = PS.getStockInfo(match);

  return [
    ...(match.isAutoDuty ? [] : [['Duty point', `${PS.formatNumber(PS.flowFromBase(match.flow))} ${PS.getFlowUnitText()} @ ${PS.formatNumber(PS.headFromBase(match.requiredHead))} ${PS.getHeadUnitText()}`]]),
    ...(stock ? [['Stock', `${stock.label}${stock.note ? ` - ${stock.note}` : ''}`]] : []),
    ['BEP flow', `${PS.formatNumber(PS.flowFromBase(match.bepFlow))} ${PS.getFlowUnitText()}`],
    ['Available head', `${PS.formatNumber(PS.headFromBase(match.predictedHead))} ${PS.getHeadUnitText()}`],
    ['Power', `${PS.formatNumber(PS.powerFromBase(match.power))} ${PS.getPowerUnitText()}`],
    ['NPSHr', match.npshr !== null && PS.hasUsableNpshData(match) ? `${PS.formatNumber(PS.headFromBase(match.npshr))} ${PS.getHeadUnitText()}` : '-'],
    ['Efficiency', match.efficiency !== null ? `${PS.formatNumber(match.efficiency)} %` : match.bepEfficiency !== null ? `${PS.formatNumber(match.bepEfficiency)} % BEP` : '-'],
    ['Unit efficiency', unitEff?.unitEfficiencyPct !== null && unitEff?.unitEfficiencyPct !== undefined ? `${PS.formatNumber(unitEff.unitEfficiencyPct)} %` : '-'],
    ['% of BEP', Number.isFinite(match.bepFlowRatio) ? `${PS.formatNumber(match.bepFlowRatio, 0)} %` : '-'],
    ['Frequency', `${PS.formatNumber(match.selectedFrequencyHz, 1)} Hz`],
    ['RPM', `${PS.formatNumber(PS.getOperatingSpeedRpm(match, motor) ?? match.selectedSpeedRpm, 0)} rpm`],
    [match.isVertical ? 'Configuration' : 'Trim', match.isVertical ? PS.getVerticalUnitLabel(match) : `${PS.formatNumber(PS.getDisplayTrimMm(match.selectedTrimMm), 0)} mm`],
    // Fixed-motor pumps (Onga/Jung) ship with an integrated motor unrelated to
    // the swappable TE3/Teco/WEG database, so getDisplayMotor returns null for
    // them - show the pump's own JSON nameplate rating (kW + phase/voltage)
    // instead of a bare "-". Southern Cross still shows its real selected motor.
    ['Motor', motor
      ? `${PS.formatNumber(motor.powerKw, 2)} kW / ${motor.poles} pole${motor.brand ? ` (${PS.motorBrandLabels[motor.brand] || motor.brand})` : ''}`
      : (PS.getFixedPumpMotorText(match) || '-')],
    ['Noise level', Number.isFinite(PS.getUnitNoiseDba(match, motor)) ? `${PS.formatNumber(PS.getUnitNoiseDba(match, motor), 0)} dBA` : '-']
  ];
};

// Pumping-side data for the printable curve sheet - everything about the
// hydraulic duty and the curve itself, no motor specifics.
PS.getPumpingInfoRows = function (match) {
  return [
    ...(match.isAutoDuty ? [] : [['Duty point', `${PS.formatNumber(PS.flowFromBase(match.flow))} ${PS.getFlowUnitText()} @ ${PS.formatNumber(PS.headFromBase(match.requiredHead))} ${PS.getHeadUnitText()}`]]),
    ['BEP flow', `${PS.formatNumber(PS.flowFromBase(match.bepFlow))} ${PS.getFlowUnitText()}`],
    ['BEP power', Number.isFinite(match.bepPower) ? `${PS.formatNumber(PS.powerFromBase(match.bepPower))} ${PS.getPowerUnitText()}` : '-'],
    ['BEP efficiency', match.bepEfficiency !== null ? `${PS.formatNumber(match.bepEfficiency)} %` : '-'],
    ['% of BEP', Number.isFinite(match.bepFlowRatio) ? `${PS.formatNumber(match.bepFlowRatio, 0)} %` : '-'],
    ['Duty flow', `${PS.formatNumber(PS.flowFromBase(match.flow))} ${PS.getFlowUnitText()}`],
    ['Duty pressure', `${PS.formatNumber(PS.headToPressure(match.requiredHead))} ${PS.getPressureUnitText()}`],
    ['Actual pump pressure', `${PS.formatNumber(PS.headToPressure(match.predictedHead))} ${PS.getPressureUnitText()}`],
    ['Duty power', `${PS.formatNumber(PS.powerFromBase(match.power))} ${PS.getPowerUnitText()}`],
    ['Duty efficiency', match.efficiency !== null ? `${PS.formatNumber(match.efficiency)} %` : '-'],
    ['NPSHr', match.npshr !== null && PS.hasUsableNpshData(match) ? `${PS.formatNumber(PS.headFromBase(match.npshr))} ${PS.getHeadUnitText()}` : '-'],
    [match.isVertical ? 'Configuration' : 'Trim', match.isVertical ? PS.getVerticalUnitLabel(match) : `${PS.formatNumber(PS.getDisplayTrimMm(match.selectedTrimMm), 0)} mm`]
  ];
};

// Construction/mounting details for the printable curve sheet, split out
// from Pumping Info and Motor Info so both stay focused on hydraulics.
PS.getPumpDetailsRows = function (match) {
  const rows = [['Pump model', PS.getPumpDisplayName(match)]];

  // Fixed-motor domestic/submergible pumps (Onga JS/OME, Jung MultiFree etc)
  // have no mounting type or swappable motor, so the Southern Cross
  // mounting/motor-frame dimension lookup below doesn't apply to them - use
  // the model-keyed per-manufacturer dimension table instead.
  if (match.fixedPump || match.curve?.fixedPump) {
    const fixedPumpDims = PS.getFixedPumpDimensionRow(match);

    rows.push(['Unit weight', Number.isFinite(fixedPumpDims?.weightKg) ? `${PS.formatNumber(fixedPumpDims.weightKg, 0)} kg` : '-']);

    return rows;
  }

  // Vertical Multistage pumps don't offer a Starline/Sovereign/Iso-Pro
  // mounting choice at all (their own base/no-base mounting options aren't
  // built yet) - the Mounting row below was previously always showing
  // "Starline (close coupled)" regardless, which is wrong for this range,
  // not just incomplete. Removed for now per the user's explicit request
  // rather than left showing an inapplicable value; PS.findDimensionRow
  // never actually finds a real row for PVMI families either way (verified
  // empirically against real data), so no genuine weight figure is lost.
  if (match.isVertical) {
    rows.push(['Unit weight', '-']);
    return rows;
  }

  const mountingType = PS.getEffectiveMountingType(match);
  const motor = PS.getEffectiveMotor(match);
  const dimensionRow = PS.findDimensionRow(match, mountingType, motor);
  const unitWeight = Number(dimensionRow?.Unitweight);
  const variant = PS.getSelectedMaterialVariant(match);

  if (variant?.partNumber) rows.push(['Part number', variant.partNumber]);
  rows.push(
    ['Mounting', PS.mountingTypeLabels[mountingType] || mountingType || '-'],
    ['Unit weight', Number.isFinite(unitWeight) && unitWeight > 0 ? `${PS.formatNumber(unitWeight, 0)} kg` : '-']
  );
  return rows;
};

// Motor-side data, kept separate from pumping info per the printable sheet
// layout - speed is shown here too since it's the motor's nameplate speed
// driving the duty, not an idealised pump speed.
PS.getMotorInfoRows = function (match) {
  const motor = PS.getDisplayMotor(match);
  const unitEff = PS.calculateUnitEfficiencyForMotor(match, motor);
  const puCode = motor ? PS.getPuCode(motor.powerKw, motor.poles) : null;
  // Fixed-motor pumps have no swappable-database motor (no brand/poles to
  // show), but they do publish their own nameplate rating - surface it here
  // instead of a "-" for the Rated power row. Brand/Poles stay "-".
  const fixedPlate = PS.getFixedPumpNameplate(match);
  // TAPS's curve sheet always prints the run-out "MAX POWER DRAW" figure - the
  // most shaft power the pump can demand anywhere on the curve. It matters most
  // in Advanced mode, where the motor is sized to the duty and can be overloaded
  // at run-out (the red undersized-motor warning flags that separately).
  const overload = PS.getMotorOverloadInfo(match, motor);

  return [
    ['Brand', motor?.brand ? (PS.motorBrandLabels[motor.brand] || motor.brand) : '-'],
    ['Rated power', motor
      ? `${PS.formatNumber(motor.powerKw, 2)} kW`
      : (fixedPlate ? `${PS.formatNumber(fixedPlate.powerKw, 2)} kW` : '-')],
    ...(overload ? [['Max power draw', `${PS.formatNumber(overload.maxPowerDrawKw, 2)} kW${overload.overloaded ? ' (overloads motor)' : ''}`]] : []),
    ['Poles', motor ? `${motor.poles}` : '-'],
    ['Frequency', `${PS.formatNumber(match.selectedFrequencyHz, 1)} Hz`],
    ['Speed', `${PS.formatNumber(PS.getOperatingSpeedRpm(match, motor) ?? match.selectedSpeedRpm, 0)} rpm`],
    ['Motor efficiency at load', unitEff?.motorEffPct !== null && unitEff?.motorEffPct !== undefined ? `${PS.formatNumber(unitEff.motorEffPct)} %` : '-'],
    ['Load', unitEff?.loadFraction !== null && unitEff?.loadFraction !== undefined ? `${PS.formatNumber(unitEff.loadFraction * 100)} %` : '-'],
    ['Unit efficiency', unitEff?.unitEfficiencyPct !== null && unitEff?.unitEfficiencyPct !== undefined ? `${PS.formatNumber(unitEff.unitEfficiencyPct)} %` : '-'],
    ['PU code', puCode || '-'],
    ['Noise level', Number.isFinite(PS.getUnitNoiseDba(match, motor)) ? `${PS.formatNumber(PS.getUnitNoiseDba(match, motor), 0)} dBA` : '-']
  ];
};

// Combined-unit figures for a "pumps in parallel" setup - each pump still
// draws its own rated power and runs at its own duty point, so the total
// unit power is simply N times one pump's power; total noise follows the
// standard combined-sound-level formula for N identical, co-located sources
// (doubling the source count adds ~3 dBA, not double the dBA value).
PS.getParallelInfoRows = function (match) {
  const pumpCount = PS.state.parallelPumpCount || 1;

  if (pumpCount <= 1) return [];

  const motor = PS.getEffectiveMotor(match);
  const unitNoiseDba = PS.getUnitNoiseDba(match, motor);
  const totalNoiseDba = Number.isFinite(unitNoiseDba)
    ? unitNoiseDba + 10 * Math.log10(pumpCount)
    : null;
  const totalPowerKw = PS.powerFromBase(match.power) * pumpCount;

  return [
    ['Pumps in parallel', `${pumpCount}`],
    ['Total unit power', `${PS.formatNumber(totalPowerKw)} ${PS.getPowerUnitText()}`],
    ['Total unit noise level', totalNoiseDba !== null ? `${PS.formatNumber(totalNoiseDba, 0)} dBA` : '-']
  ];
};

// The extra VSD speed curves the customer overlaid on the detail chart, as
// printable rows - one per curve, in the same order (and therefore the same
// legend colours) as the chart itself. Every figure here is already computed
// by the same engine that drew the overlay (PS.getExtraCurveMatches ->
// PS.evaluateAdjustedCurve): the head/power/efficiency/NPSHr are that speed's
// values at the *main duty flow*, which is what the curve sheet needs to show
// - it's the "what do I get at this duty if I slow the pump down" question.
PS.getExtraCurveTableRows = function (match) {
  const extras = PS.getExtraCurveMatches(match);

  if (!extras.length) return [];

  const motor = PS.getEffectiveMotor(match);

  return extras.map((extra, index) => {
    const rpm = PS.frequencyToRpm(motor, extra.selectedFrequencyHz) || extra.selectedSpeedRpm;

    // Slowing the pump down while holding the duty flow can push that flow well
    // past the slower curve's own BEP, out where the fitted efficiency
    // polynomial stops being trustworthy and PS.evaluateAdjustedCurve's
    // Math.min(100, ...) clamp bites. A printed "100.00 %" would read as a real
    // figure, so a clamped value prints as "-" instead (~6% of speed steps in a
    // sweep across the range hit this; every other step returns a normal
    // 70-92%). Power is unaffected - it follows from head/flow/density.
    const efficiencyClamped = extra.efficiency !== null && extra.efficiency >= 99.99;

    return [
      `Curve ${index + 2}`,
      `${PS.formatNumber(extra.selectedFrequencyHz, 1)} Hz`,
      `${PS.formatNumber(rpm, 0)} rpm`,
      `${PS.formatNumber(PS.headFromBase(extra.predictedHead))} ${PS.getHeadUnitText()}`,
      extra.power !== null ? `${PS.formatNumber(PS.powerFromBase(extra.power))} ${PS.getPowerUnitText()}` : '-',
      extra.efficiency !== null && !efficiencyClamped ? `${PS.formatNumber(extra.efficiency)} %` : '-',
      extra.npshr !== null && PS.hasUsableNpshData(extra) ? `${PS.formatNumber(PS.headFromBase(extra.npshr))} ${PS.getHeadUnitText()}` : '-'
    ];
  });
};

// The extra duty points the customer plotted on the detail chart, as printable
// rows - taken from the same PS.getFilledDutyPoints the chart plots, so the
// card and the markers can never disagree (blank rows are skipped by both).
// These are plain flow/head markers typed straight into the adjustment panel,
// so they are already in the current display units and print as-is with no
// base conversion, exactly as the chart plots them.
PS.getExtraDutyPointTableRows = function () {
  return PS.getFilledDutyPoints().map(({ index, flow, head }) => [
    `Duty point ${index + 2}`,
    `${PS.formatNumber(flow)} ${PS.getFlowUnitText()}`,
    `${PS.formatNumber(head)} ${PS.getHeadUnitText()}`
  ]);
};

// Fluid properties active at the time of export, pulled from the same duty
// state the curve correction itself was calculated against.
PS.getFluidInfoRows = function () {
  const duty = PS.state.duty || {};
  const fluid = PS.getFluidArray().find(item => item.id === duty.fluidId);

  return [
    ['Fluid', fluid?.name || duty.fluidId || '-'],
    ['Temperature', `${PS.formatNumber(duty.temperatureC, 1)} °C`],
    ['Density', `${PS.formatNumber(duty.densityKgL, 3)} kg/L`],
    ['Viscosity', `${PS.formatNumber(duty.viscosityCp, 2)} cP`]
  ];
};

PS.renderAdjustmentPanel = function (targetId, match, chartCanvasId, chartKey, summaryId) {
  const panel = document.getElementById(targetId);

  if (!panel || !match) {
    return;
  }

  const productHandle = match.curve.shopify?.handle;
  const productUrl = productHandle ? `/products/${productHandle}` : null;

  // Onga fixed pumps (OME/JS etc) ship with their own integrated motor and
  // no impeller trim - there's no 43 South motor to select and nothing to
  // trim, so the Motor Selection card and the trim/stage stepper below are
  // both hidden rather than offering a brand/size pick (or an "undersized"
  // warning against it) that doesn't apply to this pump at all.
  const isFixedPump = !!(match.fixedPump || match.curve?.fixedPump);

  const adjustLabel = match.isVertical ? 'Configuration' : 'Trim diameter';
  const adjustValue = match.isVertical
    ? (match.curve?.id || match.curve?.unitCode || match.stages)
    : PS.formatNumber(PS.getDisplayTrimMm(match.selectedTrimMm), 0);
  const verticalCurveOptions = match.isVertical
    ? PS.getVerticalStackCurves(PS.getCurvesArray().filter(curve => PS.getPumpFamily(curve) === match.family))
    : [];
  // The dropdown lists one build per stack, but the search may well have
  // landed on the other one (a single-phase search returns S curves), so the
  // selected option is found by stack rather than by exact curve.
  const selectedStack = match.isVertical ? PS.getVerticalCurveStackCode(match.curve) : '';

  // Poles/power are chosen brand-agnostically first - the brand dropdown is
  // then narrowed down to whichever brands actually stock the chosen size,
  // rather than the size choice being limited to whatever brand happens to
  // be selected. If the brand sitting in state can't actually supply the
  // selected size, switch to one that can before resolving the real motor,
  // so the rest of the panel (undersized check, RPM conversion, etc.) is
  // working off a motor that genuinely exists.
  let motor = PS.getEffectiveMotor(match);
  const poleOptions = PS.getAvailablePoles();
  const selectedPoles = motor?.poles ?? poleOptions[0];
  const powerOptions = PS.getAllMotorSizes()
    .filter(size => size.poles === selectedPoles)
    .sort((a, b) => a.powerKw - b.powerKw);
  const coveringBrands = PS.getBrandsForMotorSize(selectedPoles, motor?.powerKw);

  if (motor?.powerKw && !coveringBrands.some(({ value }) => value === PS.state.selectedMotorBrand)) {
    PS.state.selectedMotorBrand = coveringBrands[0]?.value || PS.state.selectedMotorBrand;
    motor = PS.getEffectiveMotor(match);
  }

  const motorBrand = PS.state.selectedMotorBrand || 'te3';
  // A Vertical Multistage unit ships with a fixed factory motor that its own
  // run-out power is allowed to sit slightly above (see
  // PS.getVerticalUnitMotorKw) - warning that a 5.5 kW SBI "needs" 5.80 kW
  // would be flagging the pump as Southern Cross builds it. At mains its real
  // requirement is its nameplate; the run-out figure still prints on the Motor
  // Info card as "Max power draw" exactly as TAPS shows it. Run it ABOVE mains
  // and the requirement becomes the real demand at that speed, so the warning
  // below fires and names the motor size to step up to. Every other pump keeps
  // the run-out comparison unchanged.
  const factoryMotorKw = PS.getVerticalUnitMotorKw(match);
  const requiredKw = factoryMotorKw !== null
    ? PS.getMotorSizingRequirementKw(match)
    : (PS.getMatchWorstCasePowerKw(match) ?? match.power);
  const undersized = motor?.powerKw && Number.isFinite(requiredKw) && motor.powerKw < requiredKw;
  // Overspeeding an SBI is an Advanced-mode decision (see the speed control
  // below), so its warning names the fix rather than just the shortfall: the
  // smallest catalogued motor that actually covers the demand at this speed.
  const overspeedUnit = factoryMotorKw !== null && PS.isVerticalUnitOverspeed(match);
  const overspeedMotorSize = overspeedUnit && undersized
    ? PS.selectMotorSizeForLoad(motor.poles, requiredKw)
    : null;
  // Basic mode caps an SBI's speed control at mains (see
  // PS.getSpeedAdjustmentCeilingRpm) - more head comes from more stages there,
  // and overspeeding is an Advanced-mode decision because it needs a motor the
  // unit isn't built with. Held in rpm and converted for display, since the
  // control can be showing either unit.
  const speedCeilingRpm = PS.getSpeedAdjustmentCeilingRpm(match);
  const speedCeilingHz = speedCeilingRpm !== null ? PS.rpmToFrequency(motor, speedCeilingRpm) : null;
  // Power supply is a motor property now (see PS.getEffectiveMotorPhase). The
  // single-phase option is offered only where the pump can actually take it,
  // and says why when it can't rather than just going missing.
  const singlePhase = PS.getSinglePhaseAvailability(match);
  const motorPhase = PS.getEffectiveMotorPhase(match);
  // A single-phase motor runs at whatever speed the mains gives it, so the
  // frequency stepper and the extra-speed curve overlays don't apply to it.
  const canAdjustSpeed = PS.supportsSpeedAdjustment(match);
  const limitWarnings = PS.getPumpLimitWarnings(match);
  const speedUnitDisplay = PS.state.speedDisplayUnit || 'hz';

  // System curve is an Advanced-mode tool shown only on the single-pump detail
  // view (the fit needs a real duty point, so not on the model-browse BEP
  // stand-in). Basic mode hides it entirely.
  const systemCurveAdvanced = PS.state.selectionMode === 'advanced'
    && chartKey === 'detail'
    && match.isAutoDuty !== true;

  const systemStaticHeadDisplay = PS.state.systemCurve?.staticHeadBase != null
    ? PS.formatNumber(PS.headFromBase(PS.state.systemCurve.staticHeadBase), 1)
    : '';

  let systemOperatingReadout = '';
  if (systemCurveAdvanced && PS.state.systemCurve?.enabled) {
    const operatingPoint = PS.getSystemCurveOperatingPoint(match);
    systemOperatingReadout = operatingPoint
      ? `<p class="pump-adjustment-hint" style="margin:6px 0 0; font-weight:600;">Operating point: ${PS.formatNumber(operatingPoint.flow, 1)} ${PS.getFlowUnitText()} @ ${PS.formatNumber(operatingPoint.head, 1)} ${PS.getHeadUnitText()}</p>`
      : `<p class="pump-adjustment-hint" style="margin:6px 0 0; color:#b00020;">No operating point &ndash; set a static head below the duty head (${PS.formatNumber(PS.headFromBase(match.requiredHead), 1)} ${PS.getHeadUnitText()}).</p>`;
  }

  panel.innerHTML = `
    ${isFixedPump ? '' : `
    <h3>Motor Selection</h3>

    <div class="pump-adjustment-row">
      <label>
        Power supply<br>
        <select id="${targetId}-motor-phase">
          <option value="3" ${motorPhase === 3 ? 'selected' : ''}>3 phase</option>
          <option value="1" ${motorPhase === 1 ? 'selected' : ''} ${singlePhase.ok ? '' : 'disabled'}>Single phase</option>
        </select>
      </label>

      <label>
        Motor brand<br>
        <select id="${targetId}-motor-brand">
          ${coveringBrands.map(({ value, label }) =>
            `<option value="${value}" ${value === motorBrand ? 'selected' : ''}>${label}</option>`
          ).join('')}
        </select>
      </label>

      <div class="pump-adjustment-subrow">
        <label>
          Poles<br>
          <select id="${targetId}-motor-poles">
            ${poleOptions.map(p =>
              `<option value="${p}" ${p === selectedPoles ? 'selected' : ''}>${p}</option>`
            ).join('')}
          </select>
        </label>

        <label>
          Power (kW)<br>
          <select id="${targetId}-motor-power">
            ${powerOptions.map(size =>
              `<option value="${size.powerKw}" ${motor && Math.abs(size.powerKw - motor.powerKw) < 0.01 ? 'selected' : ''}>${PS.formatNumber(size.powerKw, 2)} kW</option>`
            ).join('')}
          </select>
        </label>
      </div>

      <button id="${targetId}-motor-apply" type="button" style="align-self:end;">Apply</button>
    </div>

    ${singlePhase.ok ? '' : `<p class="pump-adjustment-hint" style="margin:2px 0 0;">Single phase not available &ndash; ${singlePhase.reason}.</p>`}
    ${motorPhase === 1 && !PS.hasSinglePhaseMotorData() ? `<p class="pump-adjustment-hint" style="margin:2px 0 0; color:#8a5a00;">No single-phase motors in the motor file yet, so the figures below are still the three-phase motor's. They will re-solve at the single-phase speed once those motors are loaded.</p>` : ''}
    ${undersized ? `<p class="pump-warning" style="color:#b00020;">Warning: ${overspeedUnit
      ? `at ${PS.formatNumber(match.selectedFrequencyHz, 1)} Hz this unit needs ${PS.formatNumber(requiredKw, 2)} kW &ndash; more than the ${PS.formatNumber(factoryMotorKw, 2)} kW motor it is built with. ${overspeedMotorSize ? `Increase the motor size above to at least ${PS.formatNumber(overspeedMotorSize.powerKw, 2)} kW` : 'Increase the motor size above'}, or drop the speed back to ${PS.formatNumber(PS.unitSettings.frequency || 50, 1)} Hz.`
      : `selected motor (${PS.formatNumber(motor.powerKw, 2)} kW) is smaller than the pump's required power (${PS.formatNumber(requiredKw, 2)} kW) at this duty.`}</p>` : ''}
    `}

    ${limitWarnings.map(warning => `<p class="pump-warning" style="color:#b00020;">Warning: ${warning}</p>`).join('')}

    <button class="pump-adjustment-toggle" type="button" data-adjust-toggle="curve">
      Pump Curve Adjustment <span>▾</span>
    </button>

    <div class="pump-adjustment-content${PS.state.openAdjustSections.has('curve') ? ' is-open' : ''}" data-adjust-content="curve">
      <div class="pump-adjustment-row">
        ${isFixedPump ? '' : `
        <label>
          ${adjustLabel}<br>
          ${match.isVertical ? `
          <select id="${targetId}-adjust">
            ${verticalCurveOptions.map(curve =>
              `<option value="${curve.id || curve.unitCode}" ${PS.getVerticalCurveStackCode(curve) === selectedStack ? 'selected' : ''}>${PS.getVerticalCurveLabel(curve)}</option>`
            ).join('')}
          </select>
          ` : `
          <button id="${targetId}-adjust-down" type="button">-</button>
          <input id="${targetId}-adjust" type="number" step="1" value="${adjustValue}" style="width:80px;">
          <button id="${targetId}-adjust-up" type="button">+</button>
          `}
        </label>
        `}

        ${canAdjustSpeed && (!isFixedPump || match.speedAdjustable) && (match.controlType === 'vsd' || match.controlType === 'speedRange') ? `
        <label>
          Speed adjustment<br>
          <button id="${targetId}-frequency-down" type="button">-</button>
          <input id="${targetId}-frequency" type="number" step="0.5" value="${(PS.state.speedDisplayUnit || (match.controlType === 'speedRange' ? 'rpm' : 'hz')) === 'rpm' ? PS.formatNumber(match.selectedSpeedRpm, 0) : PS.formatNumber(match.selectedFrequencyHz, 1)}" ${match.speedAdjustable && match.minFrequencyHz && match.maxFrequencyHz ? `min="${match.minFrequencyHz}" max="${match.maxFrequencyHz}"` : ''}${speedCeilingRpm !== null ? ` max="${(PS.state.speedDisplayUnit || 'hz') === 'rpm' ? PS.formatNumber(speedCeilingRpm, 0) : PS.formatNumber(speedCeilingHz, 1)}"` : ''} style="width:80px;">
          <button id="${targetId}-frequency-up" type="button">+</button>
          <select id="${targetId}-speed-unit">
            <option value="hz" ${(PS.state.speedDisplayUnit || (match.controlType === 'speedRange' ? 'rpm' : 'hz')) === 'hz' ? 'selected' : ''}>Hz</option>
            <option value="rpm" ${(PS.state.speedDisplayUnit || (match.controlType === 'speedRange' ? 'rpm' : 'hz')) === 'rpm' ? 'selected' : ''}>RPM</option>
          </select>
        </label>
        <span id="${targetId}-speed-label" style="display:none;">Frequency</span>
        ${speedCeilingRpm !== null ? `<p class="pump-adjustment-hint" style="flex-basis:100%; margin:4px 0 0;">Capped at mains speed &ndash; this unit is built with a ${PS.formatNumber(factoryMotorKw, 2)} kW motor. For more head, add stages; to run it faster than mains, switch to Advanced.</p>` : ''}
        ` : ''}

        <label>
          Pumps in parallel<br>
          <button id="${targetId}-parallel-down" type="button">-</button>
          <input id="${targetId}-parallel" type="number" step="1" min="1" value="${PS.state.parallelPumpCount || 1}" style="width:80px;">
          <button id="${targetId}-parallel-up" type="button">+</button>
        </label>
      </div>

      ${(!isFixedPump || (canAdjustSpeed && match.speedAdjustable && (match.controlType === 'vsd' || match.controlType === 'speedRange'))) ? `
      <div class="pump-adjustment-row">
        <button id="${targetId}-apply" type="button">Apply</button>
      </div>
      ` : ''}

      ${chartKey === 'detail' ? `
      <div class="pump-adjustment-row">
        <label>
          <input id="${targetId}-duty-visible" type="checkbox" ${PS.state.dutyPointVisible !== false ? 'checked' : ''}>
          Show duty point on chart
        </label>
      </div>
      ` : ''}
    </div>

    <button class="pump-adjustment-toggle" type="button" data-adjust-toggle="duty-points">
      Duty Points <span>▾</span>
    </button>

    <div class="pump-adjustment-content${PS.state.openAdjustSections.has('duty-points') ? ' is-open' : ''}" data-adjust-content="duty-points">
      ${(PS.state.dutyPoints || []).map((point, pointIndex) => `
        <div class="pump-adjustment-row" data-duty-point-row="${pointIndex}" style="flex-direction:row; align-items:center; flex-wrap:wrap; gap:8px;">
          <input data-duty-point-flow="${pointIndex}" type="number" step="0.1" value="${point.flow ?? ''}" placeholder="Flow (${PS.getFlowUnitText()})" style="width:90px;">
          <input data-duty-point-head="${pointIndex}" type="number" step="0.1" value="${point.head ?? ''}" placeholder="Head (${PS.getHeadUnitText()})" style="width:90px;">
          <button data-duty-point-remove="${pointIndex}" type="button" title="Remove" aria-label="Remove">&times;</button>
        </div>
      `).join('')}

      <div class="pump-adjustment-row">
        <button id="${targetId}-duty-point-add" type="button">Add duty point</button>
      </div>
    </div>

    ${chartKey === 'detail' && match.controlType === 'vsd' && canAdjustSpeed ? `
    <button class="pump-adjustment-toggle" type="button" data-adjust-toggle="extra-curves">
      Additional Curves <span>▾</span>
    </button>

    <div class="pump-adjustment-content${PS.state.openAdjustSections.has('extra-curves') ? ' is-open' : ''}" data-adjust-content="extra-curves">
      ${(PS.state.extraCurveSpecs || []).map((spec, specIndex) => {
        const rpm = speedUnitDisplay === 'rpm' ? PS.frequencyToRpm(PS.getEffectiveMotor(match), spec.valueHz) : null;
        const displayValue = speedUnitDisplay === 'rpm' ? rpm : spec.valueHz;

        return `
        <div class="pump-adjustment-row" data-extra-curve-row="${specIndex}" style="flex-direction:row; align-items:center; flex-wrap:wrap; gap:8px;">
          <input data-extra-curve-value="${specIndex}" type="number" step="${speedUnitDisplay === 'rpm' ? '1' : '0.5'}" value="${PS.formatNumber(displayValue, speedUnitDisplay === 'rpm' ? 0 : 1)}" style="width:70px;">
          <span>${speedUnitDisplay === 'rpm' ? 'RPM' : 'Hz'}</span>
          <button data-extra-curve-apply="${specIndex}" type="button">${spec.pending ? 'Show curve' : 'Apply'}</button>
          <button data-extra-curve-remove="${specIndex}" type="button" title="Remove" aria-label="Remove">&times;</button>

          ${spec.pending ? '<p class="pump-warning" style="margin:0; flex-basis:100%;">Pick a speed, then press Show curve.</p>' : ''}
        </div>
      `;
      }).join('')}

      <div class="pump-adjustment-row">
        <button id="${targetId}-extra-curve-add" type="button" ${(PS.state.extraCurveSpecs || []).length >= 3 ? 'disabled' : ''}>Add curve</button>
      </div>
    </div>
    ` : ''}

    <button class="pump-adjustment-toggle" type="button" data-adjust-toggle="fluid">
      Fluid <span>▾</span>
    </button>

    <div class="pump-adjustment-content${PS.state.openAdjustSections.has('fluid') ? ' is-open' : ''}" data-adjust-content="fluid">
      <div class="pump-adjustment-row">
        <label>
          Fluid<br>
          <select id="${targetId}-fluid-select"></select>
        </label>

        <label>
          Temperature (&deg;C)<br>
          <input id="${targetId}-fluid-temperature" type="number" step="1" value="${PS.state.duty?.temperatureC ?? 20}" style="width:80px;">
        </label>

        <label>
          Density (kg/L)<br>
          <input id="${targetId}-fluid-density" type="number" step="0.001" value="${Number(PS.state.duty?.densityKgL ?? 1).toFixed(3)}" style="width:90px;">
        </label>

        <label>
          Viscosity (cP)<br>
          <input id="${targetId}-fluid-viscosity" type="number" step="0.1" value="${Number(PS.state.duty?.viscosityCp ?? 1).toFixed(2)}" style="width:90px;">
        </label>
      </div>

      <div class="pump-adjustment-row">
        <button id="${targetId}-fluid-apply" type="button">Apply</button>
      </div>
    </div>

    ${systemCurveAdvanced ? `
    <button class="pump-adjustment-toggle" type="button" data-adjust-toggle="system-curve">
      System Curve <span>▾</span>
    </button>

    <div class="pump-adjustment-content${PS.state.openAdjustSections.has('system-curve') ? ' is-open' : ''}" data-adjust-content="system-curve">
      <div class="pump-adjustment-row">
        <label>
          Static head (${PS.getHeadUnitText()})<br>
          <input id="${targetId}-system-static-head" type="number" step="0.1" min="0" value="${systemStaticHeadDisplay}" style="width:100px;">
        </label>

        <label style="align-self:end;">
          <input id="${targetId}-system-enabled" type="checkbox" ${PS.state.systemCurve?.enabled ? 'checked' : ''}>
          Show on chart
        </label>

        <button id="${targetId}-system-apply" type="button" style="align-self:end;">Apply</button>
      </div>

      <p class="pump-adjustment-hint" style="margin:4px 0 0; font-size:12px; color:#555;">
        Fits H = static head + resistance &times; Q&sup2; through the duty point. The marker shows where the pump meets this system.
      </p>

      ${systemOperatingReadout}
    </div>
    ` : ''}

    ${PS.state.selectionMode === 'advanced' && PS.isBearingCalcEligibleMatch(match) ? `
    <button class="pump-adjustment-toggle" type="button" data-adjust-toggle="analysis-tools">
      Analysis Tools <span>▾</span>
    </button>

    <div class="pump-adjustment-content${PS.state.openAdjustSections.has('analysis-tools') ? ' is-open' : ''}" data-adjust-content="analysis-tools">
      <div class="pump-action-row">
        <button id="${targetId}-bearing-calc" type="button">Bearing Load Analysis</button>
      </div>
    </div>
    ` : ''}

    ${!isFixedPump && !match.isVertical ? `
    <div class="pump-adjustment-row">
      <label>
        Pump Mounting<br>
        ${PS.isPwtFamily(match.family)
          ? `<select id="${targetId}-mounting-type" disabled>
              <option value="pwt" selected>${PS.mountingTypeLabels.pwt}</option>
            </select>`
          : `<select id="${targetId}-mounting-type">
              ${Object.keys(PS.mountingTypeLabels).filter(key => key !== 'pwt').map(key => `<option value="${key}"${PS.state.selectedMountingType === key ? ' selected' : ''}>${PS.mountingTypeLabels[key]}</option>`).join('')}
            </select>`}
      </label>
    </div>
    ` : ''}

    <div class="pump-action-row">
      ${productUrl ? `<a href="${productUrl}">Product Information</a>` : '<button type="button" disabled>Product Information</button>'}
      <button type="button">Request Quote</button>
      <button id="${targetId}-download-curve" type="button">Download Curve</button>
      ${PS.getCadDrawing(match) ? `<button id="${targetId}-download-cad" type="button">Download CAD Files</button>` : ''}
    </div>
  `;

  PS.wireMotorControls(targetId, match, chartCanvasId, chartKey, summaryId);
  PS.wireMountingTypeControl(targetId, match, chartCanvasId, chartKey, summaryId);
  PS.wireAdjustmentControls(targetId, match, chartCanvasId, chartKey, summaryId);
  PS.wireExportControls(targetId, match);
  PS.wireCadControls(targetId, match);
  PS.wireBearingControls(targetId, match);
  PS.wireSystemCurveControls(targetId, match, chartCanvasId, chartKey, summaryId);
  PS.wireAdjustmentRollups();
};

// Advanced-mode System Curve controls. Reads the static head (display units ->
// base), toggles the overlay, and re-renders the panel + chart. All lookups are
// null-guarded: the section is absent in Basic mode, on the model-browse view,
// and for auto-duty matches, so this must no-op cleanly when its inputs aren't
// in the DOM (same defensive pattern as wireBearingControls).
PS.wireSystemCurveControls = function (targetId, match, chartCanvasId, chartKey, summaryId) {
  const applyBtn = document.getElementById(`${targetId}-system-apply`);
  const enabledInput = document.getElementById(`${targetId}-system-enabled`);
  const headInput = document.getElementById(`${targetId}-system-static-head`);

  if (!applyBtn && !enabledInput) {
    return;
  }

  const apply = () => {
    const rawHead = headInput ? parseFloat(headInput.value) : NaN;

    PS.state.systemCurve = {
      enabled: enabledInput ? !!enabledInput.checked : !!(PS.state.systemCurve && PS.state.systemCurve.enabled),
      staticHeadBase: Number.isFinite(rawHead) ? PS.headToBase(rawHead) : null
    };

    PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
    PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
    PS.saveSession();
  };

  if (applyBtn) applyBtn.addEventListener('click', apply);
  if (enabledInput) enabledInput.addEventListener('change', apply);
};

PS.wireExportControls = function (targetId, match) {
  const button = document.getElementById(`${targetId}-download-curve`);

  if (!button) {
    return;
  }

  button.addEventListener('click', () => {
    PS.state.exportMatch = match;

    const optionsContainer = document.getElementById('curve-export-options');

    if (optionsContainer) {
      const curvesHtml = Object.keys(PS.chartModeConfig).map(mode => {
        const config = PS.chartModeConfig[mode];
        const availabilityChecker = PS.chartModeAvailabilityCheckers[mode];
        const disabled = !!availabilityChecker && !availabilityChecker(match);
        const checked = !disabled && PS.state.detailModes.has(mode) ? 'checked' : '';

        return `
          <label style="display:block; margin-bottom:4px;${disabled ? ' opacity:0.45;' : ''}">
            <input type="checkbox" data-export-mode="${mode}" ${checked} ${disabled ? 'disabled' : ''}>
            ${config.label}${disabled ? ` (no ${config.label} data for this pump)` : ''}
          </label>
        `;
      }).join('');

      const drawingsAvailable = !!PS.getGaDrawing(match);
      const drawingsChecked = drawingsAvailable && PS.state.exportIncludeGaDrawing !== false ? 'checked' : '';

      const drawingHtml = `
        <label style="display:block; margin-bottom:4px;${drawingsAvailable ? '' : ' opacity:0.45;'}">
          <input type="checkbox" data-export-drawing ${drawingsChecked} ${drawingsAvailable ? '' : 'disabled'}>
          GA Drawing${drawingsAvailable ? '' : ' (no drawing available for this pump)'}
        </label>
      `;

      optionsContainer.innerHTML = curvesHtml + drawingHtml;
    }

    const modal = document.getElementById('curve-export-modal');

    if (modal) {
      modal.style.display = 'block';
    }
  });
};

// Renders one bordered info card (title + label/value rows) for the
// printable sheet - shared by the Pumping/Motor/Fluid sections so they stay
// visually consistent.
PS.buildInfoCard = function (title, rows, full) {
  const rowsHtml = rows.map(([label, value]) => `
    <tr>
      <td class="ps-sheet-label">${label}</td>
      <td class="ps-sheet-value">${value}</td>
    </tr>
  `).join('');

  return `
    <div class="ps-sheet-card${full ? ' ps-sheet-card--full' : ''}">
      <h2>${title}</h2>
      <table>${rowsHtml}</table>
    </div>
  `;
};

// Renders one bordered card whose body is a real multi-column table with a
// header row, for the printable sheet - the label/value shape buildInfoCard
// uses doesn't suit the Additional Curves / Additional Duty Points cards,
// which compare several entries across the same set of figures. Always spans
// the full card width, since the columns need the room.
PS.buildTableCard = function (title, headers, rows) {
  const headHtml = headers.map(header => `<th class="ps-sheet-th">${header}</th>`).join('');
  const rowsHtml = rows.map(cells => `
    <tr>
      ${cells.map((cell, index) => `<td class="${index === 0 ? 'ps-sheet-label' : 'ps-sheet-value'}">${cell}</td>`).join('')}
    </tr>
  `).join('');

  return `
    <div class="ps-sheet-card ps-sheet-card--full">
      <h2>${title}</h2>
      <table><tr>${headHtml}</tr>${rowsHtml}</table>
    </div>
  `;
};

// Job-level details captured on the download modal (customer/reference/base
// type) - the curve number is a placeholder until the curve archive feature
// (see docs/curve-archive-and-quotes.md) generates real ones. Laid out as a
// single horizontal row (not the stacked label/value table the other cards
// use) since it only has four short fields and spans the full card width.
PS.getJobInfoRows = function (match, today) {
  const customer = document.getElementById('curve-export-customer')?.value || '-';
  const reference = document.getElementById('curve-export-reference')?.value || '-';
  const shareUrl = PS.buildShareableUrl(match);

  // The link is printed as a single clickable "View this result online" anchor
  // only. An earlier build also dumped the full (very long) URL as visible
  // selectable text as a fallback for PDF pipelines that drop link annotations,
  // but that flooded the sheet with the whole base64 address; buildShareableUrl
  // now emits a short URL, so the button alone is what belongs here.
  const linkValue = `<a href="${shareUrl}">View this result online</a>`;

  return [
    ['Customer', customer],
    ['Reference', reference],
    ['Curve number', '-'],
    ['Date', today],
    ['Online link', linkValue]
  ];
};

PS.buildJobInfoCard = function (title, fields) {
  const fieldsHtml = fields.map(([label, value, opts]) => `
    <div class="ps-sheet-job-field${opts && opts.fullWidth ? ' ps-sheet-job-field--full' : ''}">
      <div class="ps-sheet-job-label">${label}</div>
      <div class="ps-sheet-job-value">${value}</div>
    </div>
  `).join('');

  return `
    <div class="ps-sheet-card ps-sheet-card--full">
      <h2>${title}</h2>
      <div class="ps-sheet-job-row">${fieldsHtml}</div>
    </div>
  `;
};

// Renders the duty/BEP/motor/fluid details plus the chosen curve modes into a
// branded, print-ready sheet in a new window - reuses the same row-builder
// functions as the on-screen panel so the export never drifts out of sync.
// Page 1 (portrait) carries the data cards; page 2 (landscape) carries the
// curve, snapshotted from the offscreen export canvas (kept off-DOM via
// positioning, not display:none, so Chart.js can still lay it out properly).
PS.generateCurveSheet = function () {
  const match = PS.state.exportMatch;

  if (!match) {
    return;
  }

  const selectedModes = new Set(
    Array.from(document.querySelectorAll('#curve-export-options input[type="checkbox"]:checked'))
      .map(input => input.dataset.exportMode)
  );

  const includeGaDrawing = !!document.querySelector('#curve-export-options input[data-export-drawing]:checked');
  PS.state.exportIncludeGaDrawing = includeGaDrawing;

  if (!selectedModes.size) {
    return;
  }

  const previousAnimation = Chart.defaults.animation;
  Chart.defaults.animation = false;

  // Routed through drawDetailChart (not drawChart directly) so the sheet's
  // chart carries the same extra VSD speed curves the customer added on the
  // detail view - the extra duty point markers come along inside drawChart.
  PS.drawDetailChart('curve-export-canvas', 'export', match, selectedModes);

  Chart.defaults.animation = previousAnimation;

  setTimeout(() => {
    const canvas = document.getElementById('curve-export-canvas');
    const chartImage = canvas ? canvas.toDataURL('image/png') : '';
    const displayName = PS.getPumpDisplayName(match);
    const today = new Date().toLocaleDateString('en-NZ');
    const gaDrawing = includeGaDrawing ? PS.getGaDrawing(match) : null;
    // Only printed when the customer actually added them on the detail view -
    // both cards are omitted entirely otherwise, so the usual single-curve
    // sheet layout is unchanged.
    const extraCurveRows = PS.getExtraCurveTableRows(match);
    const extraDutyPointRows = PS.getExtraDutyPointTableRows();

    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
          <title>${displayName} - Curve Sheet</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 0;
            }

            @page landscape-page {
              size: A4 landscape;
              margin: 0;
            }

            * { box-sizing: border-box; }

            body {
              font-family: Arial, Helvetica, sans-serif;
              color: #1a1a1a;
              margin: 0;
            }

            .ps-sheet-page {
              display: flex;
              flex-direction: column;
              min-height: 297mm;
            }

            .ps-sheet-page--landscape {
              page: landscape-page;
              break-before: page;
              height: 210mm;
              min-height: 0;
            }

            .ps-sheet-content {
              padding: 0 12mm;
              display: flex;
              flex-direction: column;
              flex: 1 1 auto;
              min-height: 0;
            }

            .ps-sheet-page--landscape .ps-sheet-content {
              padding: 8mm 10mm 0;
            }

            .ps-sheet-curve-wrap {
              flex: 1 1 auto;
              min-height: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;
            }

            .ps-sheet-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 6px;
            }

            .ps-sheet-header img.ps-sheet-logo {
              height: 38px;
            }

            .ps-sheet-header .ps-sheet-meta {
              text-align: right;
              font-size: 11px;
              color: #555;
            }

            .ps-sheet-band {
              width: 100%;
              height: auto;
              display: block;
              margin-bottom: 10px;
            }

            .ps-sheet-cards {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 10px;
              margin-bottom: 10px;
            }

            .ps-sheet-card {
              border: 1px solid #cfe3e8;
              border-radius: 6px;
              padding: 8px 12px;
            }

            .ps-sheet-card.ps-sheet-card--full {
              grid-column: 1 / -1;
            }

            .ps-sheet-card h2 {
              font-size: 13px;
              margin: 0 0 6px;
              color: #fff;
              background: #00384A;
              padding: 3px 8px;
              border-radius: 4px;
              display: inline-block;
            }

            .ps-sheet-card table {
              border-collapse: collapse;
              width: 100%;
              font-size: 12px;
            }

            .ps-sheet-label {
              font-weight: bold;
              padding: 2px 10px 2px 0;
              border-bottom: 1px solid #e6eef0;
              white-space: nowrap;
            }

            .ps-sheet-value {
              padding: 2px 0;
              border-bottom: 1px solid #e6eef0;
            }

            /* Header row of the multi-column cards (Additional Curves /
               Additional Duty Points) - see PS.buildTableCard. Their value
               cells share .ps-sheet-value above, so they need their own
               left-aligned, spaced-out heading style rather than the
               bold-label-column look .ps-sheet-label gives. */
            .ps-sheet-th {
              text-align: left;
              font-size: 11px;
              font-weight: bold;
              color: #555;
              padding: 0 10px 2px 0;
              border-bottom: 1px solid #cfe3e8;
              white-space: nowrap;
            }

            .ps-sheet-card--full .ps-sheet-value {
              padding-right: 10px;
              white-space: nowrap;
            }

            .ps-sheet-job-row {
              display: flex;
              flex-wrap: wrap;
              gap: 16px;
            }

            .ps-sheet-job-field {
              flex: 1 1 0;
              min-width: 0;
            }

            .ps-sheet-job-field--full {
              flex-basis: 100%;
            }

            .ps-sheet-job-label {
              font-weight: bold;
              font-size: 11px;
              color: #555;
            }

            .ps-sheet-job-value {
              font-size: 13px;
              padding-top: 1px;
            }

            .ps-sheet-footer {
              margin-top: auto;
              padding-top: 10px;
            }

            .ps-sheet-footer img {
              width: 100%;
              display: block;
            }

            .ps-sheet-curve-page .ps-sheet-footer {
              padding-top: 10px;
            }

            .ps-sheet-curve-title {
              font-size: 16px;
              color: #00384A;
              margin: 0 0 10px;
            }

            .ps-sheet-curve-page img.ps-sheet-curve {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }

            .ps-sheet-ga-wrap {
              flex: 1 1 auto;
              min-height: 0;
              display: flex;
              gap: 16px;
            }

            .ps-sheet-ga-image {
              flex: 1 1 60%;
              display: flex;
              align-items: center;
              justify-content: center;
              min-width: 0;
            }

            .ps-sheet-ga-image img {
              max-width: 100%;
              max-height: 100%;
              width: auto;
              height: auto;
              object-fit: contain;
              display: block;
            }

            .ps-sheet-ga-side {
              flex: 1 1 40%;
              display: flex;
              flex-direction: column;
              gap: 12px;
              min-width: 0;
              overflow: hidden;
            }
          </style>
        </head>
        <body>
          <div class="ps-sheet-page">
            <img class="ps-sheet-band" src="${window.PUMP_BRAND_BAND_URL || ''}" alt="">

            <div class="ps-sheet-content">
              <div class="ps-sheet-cards">
                ${PS.buildJobInfoCard('Job Info', PS.getJobInfoRows(match, today))}
                ${PS.buildInfoCard('Pumping Info', PS.getPumpingInfoRows(match))}
                ${PS.buildInfoCard('Pump Details', PS.getPumpDetailsRows(match))}
                ${PS.buildInfoCard('Motor Info', PS.getMotorInfoRows(match))}
                ${PS.buildInfoCard('Fluid Details', PS.getFluidInfoRows())}
                ${(PS.state.parallelPumpCount || 1) > 1 ? PS.buildInfoCard('Pumps in Parallel', PS.getParallelInfoRows(match)) : ''}
                ${extraCurveRows.length ? PS.buildTableCard(
                  'Additional Curves',
                  ['Curve', 'Frequency', 'Speed', 'Head at duty flow', 'Power', 'Efficiency', 'NPSHr'],
                  extraCurveRows
                ) : ''}
                ${extraDutyPointRows.length ? PS.buildTableCard(
                  'Additional Duty Points',
                  ['Point', 'Flow', 'Head'],
                  extraDutyPointRows
                ) : ''}
              </div>
            </div>

            <div class="ps-sheet-footer">
              <img src="${window.PUMP_BRAND_FOOTER_URL || ''}" alt="43 South Ltd">
            </div>
          </div>

          <div class="ps-sheet-page ps-sheet-page--landscape ps-sheet-curve-page">
            <div class="ps-sheet-content">
              <div class="ps-sheet-header">
                <img class="ps-sheet-logo" src="${window.PUMP_BRAND_LOGO_URL || ''}" alt="43 South">
                <div class="ps-sheet-meta">${displayName}<br>${today}</div>
              </div>

              <p class="ps-sheet-curve-title">Performance Curve</p>

              <div class="ps-sheet-curve-wrap">
                ${chartImage ? `<img class="ps-sheet-curve" src="${chartImage}" alt="Pump curve">` : ''}
              </div>
            </div>

            <div class="ps-sheet-footer">
              <img src="${window.PUMP_BRAND_FOOTER_URL || ''}" alt="43 South Ltd">
            </div>
          </div>

          ${gaDrawing ? `
          <div class="ps-sheet-page ps-sheet-page--landscape ps-sheet-curve-page">
            <div class="ps-sheet-content">
              <div class="ps-sheet-header">
                <img class="ps-sheet-logo" src="${window.PUMP_BRAND_LOGO_URL || ''}" alt="43 South">
                <div class="ps-sheet-meta">${displayName}<br>${today}</div>
              </div>

              <p class="ps-sheet-curve-title">${gaDrawing.title}</p>

              <div class="ps-sheet-ga-wrap">
                <div class="ps-sheet-ga-image">
                  ${gaDrawing.imageUrl ? `<img src="${gaDrawing.imageUrl}" alt="${gaDrawing.title}">` : ''}
                </div>
                <div class="ps-sheet-ga-side">
                  ${PS.buildInfoCard('Pump Details', gaDrawing.fields)}
                  ${gaDrawing.dimensionTableRows.length ? PS.buildInfoCard('Dimensions', gaDrawing.dimensionTableRows) : ''}
                </div>
              </div>
            </div>

            <div class="ps-sheet-footer">
              <img src="${window.PUMP_BRAND_FOOTER_URL || ''}" alt="43 South Ltd">
            </div>
          </div>
          ` : ''}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    // The header/footer/band images load over the network inside the new
    // window - printing before they finish makes them collapse to zero
    // height, which throws off the whole page layout. Wait for every image
    // to actually load (or fail) before triggering print, with a timeout
    // fallback so a slow/broken image can't hang the print indefinitely.
    const images = Array.from(printWindow.document.images);
    const imagesReady = Promise.all(images.map(img => img.complete
      ? Promise.resolve()
      : new Promise(resolve => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      })));

    Promise.race([
      imagesReady,
      new Promise(resolve => setTimeout(resolve, 2000))
    ]).then(() => {
      printWindow.print();
    });
  }, 100);

  const modal = document.getElementById('curve-export-modal');

  if (modal) {
    modal.style.display = 'none';
  }
};

PS.wireMotorControls = function (targetId, match, chartCanvasId, chartKey, summaryId) {
  const brandSelect = document.getElementById(`${targetId}-motor-brand`);
  const polesSelect = document.getElementById(`${targetId}-motor-poles`);
  const phaseSelect = document.getElementById(`${targetId}-motor-phase`);

  // Fixed pumps (Onga OME/JS etc) have no Motor Selection card at all - see
  // the isFixedPump branch in renderAdjustmentPanel - so there's nothing to wire.
  if (!brandSelect || !polesSelect) {
    return;
  }

  // Changing the supply changes which motors exist to choose from, so the
  // brand and kW picks are cleared and re-defaulted for the new phase - the
  // same reset a brand change does. Unlike brand and poles though, phase is
  // not left staged for the customer to Apply: it renames the pump (SBI15-3S
  // vs SBI15-3T) and puts it on a different motor speed, so leaving the
  // summary and the chart showing the other phase's figures would be a quote
  // that disagrees with itself. Committing through the card's own Apply
  // button reuses the path a brand change already takes, which re-solves the
  // duty against the newly resolved motor rather than inventing a second
  // commit route that could drift from it.
  if (phaseSelect) {
    phaseSelect.addEventListener('change', event => {
      PS.state.selectedMotorPhase = Number(event.target.value);
      PS.state.selectedMotorPoles = null;
      PS.state.selectedMotorKw = null;
      PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
      document.getElementById(`${targetId}-motor-apply`)?.click();
    });
  }

  brandSelect.addEventListener('change', event => {
    PS.state.selectedMotorBrand = event.target.value;
    PS.state.selectedMotorPoles = null;
    PS.state.selectedMotorKw = null;
    PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
  });

  polesSelect.addEventListener('change', event => {
    PS.state.selectedMotorPoles = Number(event.target.value);
    PS.state.selectedMotorKw = null;
    PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
  });
};

// Mounting type (Starline/Sovereign/Iso-Pro) is a single global setting, not
// a per-pump property - the dropdown lives in each view's adjustment panel
// purely as a convenient place to set it, but changing it re-renders the
// panel (so the Bearing Load Analysis button/label update immediately) and
// applies to whichever pump is on screen, not just this one.
PS.wireMountingTypeControl = function (targetId, match, chartCanvasId, chartKey, summaryId) {
  const select = document.getElementById(`${targetId}-mounting-type`);

  if (!select) {
    return;
  }

  select.addEventListener('change', event => {
    PS.state.selectedMountingType = event.target.value;
    PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
  });
};

PS.wireAdjustmentControls = function (targetId, match, chartCanvasId, chartKey, summaryId) {
  const adjustInput = document.getElementById(`${targetId}-adjust`);
  const frequencyInput = document.getElementById(`${targetId}-frequency`);
  const speedUnitSelect = document.getElementById(`${targetId}-speed-unit`);
  const speedLabel = document.getElementById(`${targetId}-speed-label`);
  const applyButton = document.getElementById(`${targetId}-apply`);

  const familyCurves = PS.getCurvesArray().filter(curve =>
    PS.getPumpFamily(curve) === match.family
  );

  const adjustValues = match.isVertical
    ? []
    : familyCurves.map(PS.getImpellerDiameter);

  const minAdjust = adjustValues.length ? Math.min(...adjustValues) : null;
  const maxAdjust = adjustValues.length ? Math.max(...adjustValues) : null;

  // Fixed pumps (Onga OME/JS etc) have no trim/stage stepper at all - see
  // the isFixedPump branch in renderAdjustmentPanel - so adjustInput and its
  // +/- buttons don't exist; guard every reference to them below.
  if (adjustInput) {
    if (!match.isVertical) {
      adjustInput.min = minAdjust;
      adjustInput.max = maxAdjust;
    }
  }

  // Fixed-speed pumps run at the motor's nameplate speed and aren't
  // trimmed by frequency - only VSD-controlled duties expose the speed
  // unit/frequency stepper at all.
  const hasSpeedControl = !!(frequencyInput && speedUnitSelect && speedLabel);

  function speedUnit() {
    return hasSpeedControl && speedUnitSelect.value === 'rpm' ? 'rpm' : 'hz';
  }

  // Only changes the label/step/decimal places for the active unit - the
  // displayed value itself is converted explicitly wherever the unit
  // changes (see the speedUnitSelect change handler), not recomputed here,
  // so an unapplied edit in the input isn't silently discarded.
  function applySpeedDisplay() {
    if (!hasSpeedControl) return;

    if (speedUnit() === 'rpm') {
      speedLabel.textContent = 'Speed';
      frequencyInput.step = '1';
    } else {
      speedLabel.textContent = 'Frequency';
      frequencyInput.step = '0.5';
    }
  }

  // adjustInput is null for fixed pumps (no trim/stage stepper) - the Fluid
  // section's Apply button still calls this with no args to re-evaluate the
  // curve, so this can't assume the input exists. findManualMatchForFamily
  // already returns null for fixedPump curves (no impeller trim concept),
  // so this safely no-ops for them rather than crashing.
  function applyAdjustment(newValue = adjustInput ? adjustInput.value : null, newSpeedValue = hasSpeedControl ? Number(frequencyInput.value) : match.selectedFrequencyHz) {
    const boundedValue = match.isVertical
      ? String(newValue || '')
      : Math.max(minAdjust, Math.min(maxAdjust, Number(newValue)));
    const motor = PS.getEffectiveMotor(match);

    // Basic mode won't drive an SBI past mains (see
    // PS.getSpeedAdjustmentCeilingHz). Clamping here rather than trusting the
    // input's max attribute, because the +/- steppers write the value
    // programmatically and the browser doesn't enforce max on that.
    const ceilingRpm = PS.getSpeedAdjustmentCeilingRpm(match);
    const boundedSpeedValue = ceilingRpm === null
      ? newSpeedValue
      : Math.min(Number(newSpeedValue), speedUnit() === 'rpm' ? ceilingRpm : PS.rpmToFrequency(motor, ceilingRpm));

    if (hasSpeedControl && boundedSpeedValue !== newSpeedValue) {
      frequencyInput.value = PS.formatNumber(boundedSpeedValue, speedUnit() === 'rpm' ? 0 : 1);
    }

    const speedOptions = speedUnit() === 'rpm'
      ? { speedRpm: boundedSpeedValue, poles: motor.poles, motor }
      : { frequencyHz: boundedSpeedValue, poles: motor.poles, motor };

    const updatedMatch = PS.findManualMatchForFamily(
      familyCurves,
      match,
      boundedValue,
      speedOptions
    );

    if (!updatedMatch) {
      return;
    }

    PS.state.currentMatches[PS.state.currentSelectedIndex] = updatedMatch;

    PS.drawDetailChart(chartCanvasId, chartKey, updatedMatch, PS.state.detailModes);

    PS.renderDetailSummary(summaryId, updatedMatch, `${chartKey}-pump-title`);
    PS.renderAdjustmentPanel(targetId, updatedMatch, chartCanvasId, chartKey, summaryId);
  }

  // Trim/stage and Hz/RPM edits only take effect when a button is pressed
  // (the steppers below, or this Apply button) - typing a value and tabbing
  // or clicking away does not trigger a recalculation on its own. Fixed
  // pumps have neither, so this button doesn't exist for them.
  if (applyButton) {
    applyButton.addEventListener('click', () => {
      applyAdjustment();
    });
  }

  // "Search by pump model" has no externally-specified duty - the displayed
  // operating point is just the curve's own BEP scaled to the chosen trim
  // (see findModelMatchForTrim's isAutoDuty flag), so it's hidden from the
  // summary/report until the customer actually wants to check performance
  // against a real flow/head target.
  const dutyFlowInput = document.getElementById(`${targetId}-duty-flow`);
  const dutyHeadInput = document.getElementById(`${targetId}-duty-head`);
  const dutyApplyButton = document.getElementById(`${targetId}-duty-apply`);
  const dutyErrorEl = document.getElementById(`${targetId}-duty-error`);

  function showDutyError(message) {
    if (!dutyErrorEl) return;
    dutyErrorEl.textContent = message;
    dutyErrorEl.style.display = message ? 'block' : 'none';
  }

  if (dutyFlowInput && dutyHeadInput && dutyApplyButton) {
    dutyApplyButton.addEventListener('click', () => {
      const flowValue = Number(dutyFlowInput.value);
      const headValue = Number(dutyHeadInput.value);

      if (!Number.isFinite(flowValue) || flowValue <= 0 || !Number.isFinite(headValue) || headValue <= 0) {
        showDutyError('Enter a flow and head greater than zero.');
        return;
      }

      const motor = PS.getEffectiveMotor(match);
      const speedOptions = speedUnit() === 'rpm'
        ? { speedRpm: match.selectedSpeedRpm, poles: motor.poles, motor }
        : { frequencyHz: match.selectedFrequencyHz, poles: motor.poles, motor };

      const updatedMatch = PS.evaluateAdjustedCurve(match.curve, PS.flowToBase(flowValue), PS.headToBase(headValue), {
        ...speedOptions,
        trimMm: match.selectedTrimMm,
        controlType: match.controlType
      });

      if (!updatedMatch) {
        showDutyError('That flow is outside this curve\'s range at the current trim/speed - try a different value.');
        return;
      }

      showDutyError(null);

      updatedMatch.isAutoDuty = false;
      PS.state.dutyPointVisible = true;

      PS.state.currentMatches[PS.state.currentSelectedIndex] = updatedMatch;

      PS.drawDetailChart(chartCanvasId, chartKey, updatedMatch, PS.state.detailModes);

      PS.renderDetailSummary(summaryId, updatedMatch, `${chartKey}-pump-title`);
      PS.renderAdjustmentPanel(targetId, updatedMatch, chartCanvasId, chartKey, summaryId);
    });
  }

  const dutyVisibleCheckbox = document.getElementById(`${targetId}-duty-visible`);

  if (dutyVisibleCheckbox) {
    dutyVisibleCheckbox.addEventListener('change', () => {
      // In "search by pump model" mode there's no real duty point until the
      // customer sets one - checking this box shouldn't draw a synthetic dot
      // at the curve's BEP, so send them to enter a duty and press Set duty
      // point instead of silently turning it on.
      if (chartKey === 'model' && dutyVisibleCheckbox.checked && match.isAutoDuty !== false) {
        dutyVisibleCheckbox.checked = false;
        showDutyError('Enter a duty flow and head above, then press Set duty point, to show a duty point on the chart.');
        return;
      }

      showDutyError(null);
      PS.state.dutyPointVisible = dutyVisibleCheckbox.checked;
      PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
    });
  }

  if (adjustInput && match.isVertical) {
    adjustInput.addEventListener('change', () => {
      applyAdjustment();
    });
  } else if (adjustInput) {
    document.getElementById(`${targetId}-adjust-down`).addEventListener('click', () => {
      adjustInput.value = Number(adjustInput.value) - 1;
      applyAdjustment();
    });

    document.getElementById(`${targetId}-adjust-up`).addEventListener('click', () => {
      adjustInput.value = Number(adjustInput.value) + 1;
      applyAdjustment();
    });
  }

  const step = () => (speedUnit() === 'rpm' ? 1 : 0.5);

  if (hasSpeedControl) {
    document.getElementById(`${targetId}-frequency-down`).addEventListener('click', () => {
      frequencyInput.value = Number(frequencyInput.value) - step();
      applyAdjustment();
    });

    document.getElementById(`${targetId}-frequency-up`).addEventListener('click', () => {
      frequencyInput.value = Number(frequencyInput.value) + step();
      applyAdjustment();
    });

    // Defaults to Hz (RPM for engine/diesel-drive matches, which have no
    // real mains frequency), but remembers the last unit the user picked
    // across re-renders (e.g. after pressing Apply) instead of silently
    // reverting.
    speedUnitSelect.value = PS.state.speedDisplayUnit || (match.controlType === 'speedRange' ? 'rpm' : 'hz');
    applySpeedDisplay();

    speedUnitSelect.addEventListener('change', () => {
      // Convert whatever value is currently sitting in the box (typed or not
      // yet applied) into the newly selected unit, using the currently
      // selected motor's actual nameplate speed - not the curve's catalogued
      // speed - since that's what actually relates a frequency to a shaft RPM.
      const typedValue = Number(frequencyInput.value);
      const motor = PS.getEffectiveMotor(match);

      const convertedValue = speedUnit() === 'rpm'
        ? PS.frequencyToRpm(motor, typedValue)
        : PS.rpmToFrequency(motor, typedValue);

      PS.state.speedDisplayUnit = speedUnit();
      applySpeedDisplay();
      frequencyInput.value = PS.formatNumber(convertedValue, speedUnit() === 'rpm' ? 0 : 1);

      // Extra-curve rows share this same unit selector - convert whatever
      // each row currently shows (typed or already applied) into the new
      // unit in place, without re-rendering the panel and losing unapplied edits.
      document.querySelectorAll('[data-extra-curve-value]').forEach(input => {
        const typed = Number(input.value);
        const converted = speedUnit() === 'rpm'
          ? PS.frequencyToRpm(motor, typed)
          : PS.rpmToFrequency(motor, typed);

        input.value = PS.formatNumber(converted, speedUnit() === 'rpm' ? 0 : 1);
        input.step = speedUnit() === 'rpm' ? '1' : '0.5';
      });

      document.querySelectorAll('[data-extra-curve-row] span').forEach(span => {
        span.textContent = speedUnit() === 'rpm' ? 'RPM' : 'Hz';
      });
    });
  }

  // "Pumps in parallel" only adds overlay curves on the chart - it doesn't
  // change the underlying pump match, so unlike trim/speed this just
  // updates the shared state and redraws rather than recomputing a match.
  const parallelInput = document.getElementById(`${targetId}-parallel`);
  const parallelDownButton = document.getElementById(`${targetId}-parallel-down`);
  const parallelUpButton = document.getElementById(`${targetId}-parallel-up`);

  function applyParallelCount(newValue) {
    const boundedValue = Math.max(1, Math.round(Number(newValue) || 1));
    parallelInput.value = boundedValue;
    PS.state.parallelPumpCount = boundedValue;
    PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
  }

  if (parallelInput && parallelDownButton && parallelUpButton) {
    parallelDownButton.addEventListener('click', () => {
      applyParallelCount(Number(parallelInput.value) - 1);
    });

    parallelUpButton.addEventListener('click', () => {
      applyParallelCount(Number(parallelInput.value) + 1);
    });

    parallelInput.addEventListener('change', () => {
      applyParallelCount(parallelInput.value);
    });
  }

  // Extra duty points are plain flow/head markers, independent of the
  // curve/trim/speed - editing or removing one just redraws the chart, it
  // never needs to recompute a match the way trim/speed adjustments do.
  const dutyPointAddButton = document.getElementById(`${targetId}-duty-point-add`);

  if (dutyPointAddButton) {
    dutyPointAddButton.addEventListener('click', () => {
      const points = PS.state.dutyPoints || (PS.state.dutyPoints = []);

      points.push({ flow: '', head: '' });

      PS.state.openAdjustSections.add('duty-points');

      PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
    });

    document.querySelectorAll('[data-duty-point-remove]').forEach(button => {
      button.addEventListener('click', () => {
        const removeIndex = Number(button.dataset.dutyPointRemove);
        PS.state.dutyPoints.splice(removeIndex, 1);

        PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
        PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
      });
    });

    document.querySelectorAll('[data-duty-point-flow]').forEach(input => {
      input.addEventListener('change', () => {
        const pointIndex = Number(input.dataset.dutyPointFlow);
        PS.state.dutyPoints[pointIndex].flow = input.value;
        PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
      });
    });

    document.querySelectorAll('[data-duty-point-head]').forEach(input => {
      input.addEventListener('change', () => {
        const pointIndex = Number(input.dataset.dutyPointHead);
        PS.state.dutyPoints[pointIndex].head = input.value;
        PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
      });
    });
  }

  const motorPolesSelect = document.getElementById(`${targetId}-motor-poles`);
  const motorPowerSelect = document.getElementById(`${targetId}-motor-power`);
  const motorApplyButton = document.getElementById(`${targetId}-motor-apply`);

  if (motorPolesSelect && motorPowerSelect && motorApplyButton) {
    motorApplyButton.addEventListener('click', () => {
      // Picking a different motor changes the real Hz<->RPM relationship (a
      // different pole count or nameplate speed), so the trim that hit the
      // duty point before may no longer be right - search across trims at
      // the new speed for whichever one still satisfies the duty point,
      // rather than keeping whatever trim is sitting in the box.
      PS.state.selectedMotorPoles = Number(motorPolesSelect.value);
      PS.state.selectedMotorKw = Number(motorPowerSelect.value);

      const motor = PS.getEffectiveMotor(match);
      const newSpeedValue = hasSpeedControl ? Number(frequencyInput.value) : PS.unitSettings.frequency;

      const speedOptions = speedUnit() === 'rpm'
        ? { speedRpm: newSpeedValue, poles: motor.poles, motor }
        : { frequencyHz: newSpeedValue, poles: motor.poles, motor };

      // The "search by model" duty point is just the curve's own BEP scaled
      // to whatever trim the motor implies - there's no external duty to
      // hold fixed like the "search by duty" path has, so changing motor
      // here has to re-derive the trim for the new motor (mirroring the
      // Load Pump flow) rather than searching for a trim that reproduces
      // the *previous* motor's BEP-derived point. If the user has since set
      // a real duty point via the adjustment panel (isAutoDuty === false),
      // that duty takes precedence and must survive the motor change instead
      // of being discarded back to a fresh BEP-derived one.
      const bestMatch = chartKey === 'model'
        ? (() => {
          // Trim the motor can drive without overloading, at that motor's own
          // real full-load speed (see getModelMaxTrimForMotor) - so picking a
          // smaller motor (or a slower brand) here settles on the correct
          // largest trim for it, mirroring the Load Pump sizing.
          const trimMm = PS.getModelMaxTrimForMotor(match.curve, familyCurves, motor);

          if (!trimMm) return null;

          if (match.isAutoDuty === false) {
            const updated = PS.evaluateAdjustedCurve(match.curve, match.flow, match.requiredHead, {
              ...speedOptions,
              trimMm,
              controlType: match.controlType
            });
            if (updated) updated.isAutoDuty = false;
            return updated;
          }

          return PS.findModelMatchForTrim(match.curve, trimMm, motor);
        })()
        : PS.findBestTrimForMotorChange(familyCurves, match, speedOptions);

      if (!bestMatch) {
        return;
      }

      adjustInput.value = match.isVertical ? (bestMatch.curve?.id || bestMatch.curve?.unitCode) : bestMatch.selectedTrimMm;

      PS.state.currentMatches[PS.state.currentSelectedIndex] = bestMatch;

      PS.drawDetailChart(chartCanvasId, chartKey, bestMatch, PS.state.detailModes);

      PS.renderDetailSummary(summaryId, bestMatch, `${chartKey}-pump-title`);
      PS.renderAdjustmentPanel(targetId, bestMatch, chartCanvasId, chartKey, summaryId);
    });
  }

  // Lets the customer overlay the same pump at extra VSD speeds/frequencies
  // alongside the main curve, to see its operating envelope across the
  // drive's range on one chart - same pump and trim, only speed varies.
  const extraCurveAddButton = document.getElementById(`${targetId}-extra-curve-add`);

  if (extraCurveAddButton) {
    extraCurveAddButton.addEventListener('click', () => {
      const specs = PS.state.extraCurveSpecs || (PS.state.extraCurveSpecs = []);

      if (specs.length >= 3) return;

      // Default each newly added curve to a speed visibly different from the
      // main curve and from any curves already added, stepping down through
      // the VSD's range - cloning the main curve's own current speed would
      // just draw an identical, indistinguishable line on top of it.
      const usedHz = [match.selectedFrequencyHz, ...specs.map(spec => spec.valueHz)];
      const range = PS.getVsdFrequencyRange();
      const nextHz = range
        .slice()
        .sort((a, b) => b - a)
        .find(hz => !usedHz.some(used => Math.abs(used - hz) < 0.5)) || range[0];

      // Newly added rows start pending - they're not drawn on the chart until
      // the customer picks a speed and presses that row's own Apply button,
      // rather than immediately appearing at this default speed. The value is
      // always stored in Hz; the row displays it in whichever unit the main
      // curve's speed-unit selector is currently set to.
      specs.push({ valueHz: nextHz, pending: true });

      PS.state.openAdjustSections.add('extra-curves');

      PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
    });

    document.querySelectorAll('[data-extra-curve-remove]').forEach(button => {
      button.addEventListener('click', () => {
        const removeIndex = Number(button.dataset.extraCurveRemove);
        PS.state.extraCurveSpecs.splice(removeIndex, 1);

        PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
        PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
      });
    });

    // Each row applies independently - typing a new value only takes effect
    // once that row's own Apply button is pressed, same as the main
    // trim/speed control above, so editing a different row never silently
    // discards an unapplied edit. The value is interpreted in whatever unit
    // the shared speed-unit selector above is currently showing.
    document.querySelectorAll('[data-extra-curve-apply]').forEach(button => {
      button.addEventListener('click', () => {
        const specIndex = Number(button.dataset.extraCurveApply);
        const spec = PS.state.extraCurveSpecs[specIndex];
        const valueInput = document.querySelector(`[data-extra-curve-value="${specIndex}"]`);

        if (!spec || !valueInput) return;

        const typedValue = Number(valueInput.value);
        spec.valueHz = speedUnit() === 'rpm'
          ? PS.rpmToFrequency(PS.getEffectiveMotor(match), typedValue)
          : typedValue;
        spec.pending = false;

        PS.drawDetailChart(chartCanvasId, chartKey, match, PS.state.detailModes);
        PS.renderAdjustmentPanel(targetId, match, chartCanvasId, chartKey, summaryId);
      });
    });
  }

  // Lets the customer override the fluid (and therefore the viscosity/
  // density correction applied to the curve) from inside the adjustment
  // panel - mirrors the global duty-page fluid inputs, but only takes
  // effect once Apply is pressed, same as the trim/speed controls above.
  const fluidSelect = document.getElementById(`${targetId}-fluid-select`);
  const fluidTemperatureInput = document.getElementById(`${targetId}-fluid-temperature`);
  const fluidDensityInput = document.getElementById(`${targetId}-fluid-density`);
  const fluidViscosityInput = document.getElementById(`${targetId}-fluid-viscosity`);
  const fluidApplyButton = document.getElementById(`${targetId}-fluid-apply`);

  if (fluidSelect && fluidApplyButton) {
    const fluids = PS.getFluidArray();

    fluidSelect.innerHTML = fluids
      .map(fluid => `<option value="${fluid.id}">${fluid.name}</option>`)
      .join('');

    fluidSelect.value = PS.state.duty?.fluidId
      || (fluids.some(fluid => fluid.id === 'water') ? 'water' : (fluids[0]?.id || ''));

    function refreshFluidProperties() {
      const fluid = fluids.find(item => item.id === fluidSelect.value);

      if (!fluid) return;

      const props = PS.getFluidPropertiesAtTemperature(fluid, Number(fluidTemperatureInput.value) || 20);

      fluidDensityInput.value = Number(props.densityKgL).toFixed(3);
      fluidViscosityInput.value = Number(props.viscosityCp).toFixed(2);
    }

    // Density/viscosity inputs already carry the currently-applied values
    // from the markup above - only recompute them from the fluid's lookup
    // table when the customer actually changes fluid or temperature, so a
    // manually-typed density/viscosity survives pressing Apply and
    // re-rendering the panel.
    fluidSelect.addEventListener('change', refreshFluidProperties);
    fluidTemperatureInput.addEventListener('change', refreshFluidProperties);

    fluidApplyButton.addEventListener('click', () => {
      PS.state.duty = {
        ...PS.state.duty,
        fluidId: fluidSelect.value,
        temperatureC: Number(fluidTemperatureInput.value),
        densityKgL: Number(fluidDensityInput.value),
        viscosityCp: Number(fluidViscosityInput.value)
      };

      applyAdjustment();
    });
  }
};

PS.wireAdjustmentRollups = function () {
  document.querySelectorAll('[data-adjust-toggle]').forEach(button => {
    button.addEventListener('click', () => {
      const content = button.nextElementSibling;
      const section = button.dataset.adjustToggle;

      if (content) {
        const open = content.classList.toggle('is-open');

        if (open) {
          PS.state.openAdjustSections.add(section);
        } else {
          PS.state.openAdjustSections.delete(section);
        }
      }
    });
  });
};
